import { RouterModule } from '@angular/router';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { RatingModule } from 'primeng/rating';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
// import { Product, ProductService } from '../service/product.service';
import { Product, ProductService } from '../pages/service/product.service';
import { MenuItem } from 'primeng/api';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu'; // ✅ Import this
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { catchError, debounce, distinctUntilChanged, finalize, map, switchMap, take, takeUntil } from 'rxjs/operators';
import { AppTopbar } from '../layout/component/app.topbar';
import { OrderDraftService } from '../services/order-draft.service'; // Import your service for order drafts
// If you're using PrimeNG table
// ✅ Import MenuItem
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ArStatementService } from '../services/ArStatementService';
import { RoleAccessService } from '../auth/role-access.service';
import { UserRole } from '../auth/roles.enum';
import { AppFeature } from '../auth/features.enum';
import { resolveCreditRestrictionFromGenerateOutput, isCreditRestrictionActive, isCreditLimitCheckEnabledForDivision, CreditRestrictionResult, resolveReferenceOrderIdFromGenerateOutput, shouldSkipCreditLimitCheck, shouldSkipCreditLimitOnPicklist, shouldSkipCreditLimitProcessingGate, isCreditLimitApprovedOnOrder, CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH, resolveCreditLimit3, isCreditLimitSoftBypassUser, resolveUserEmail, logCreditLimitBypassDebug, CreditLimitDialogData, CreditLimitDialogKind, getCreditLimitBypassContactNote, formatCreditLimitDialogNote, mapCreditRestrictionToDialog, isCreditNoteOrder, resolveOrderTypeCode } from '../item-details/item-utils';
import { CreditLimitDialogContentComponent } from '../item-details/credit-limit-dialog-content/credit-limit-dialog-content.component';
import { MarginApprovalDialogContentComponent } from '../item-details/margin-approval-dialog-content/margin-approval-dialog-content.component';
import {
    itemDetailsRouteCommands,
    persistItemDetailsVersion
} from '../item-details/item-details-routing.util';
import {
    isMarginApprovalEnabledForDivision,
    buildMarginApprovalSummary,
    getMarginBypassContactNote,
    getMarginApproverProceedNote,
    getMarginBlockedApprovalNotice,
    isMarginApprovalUserFromStorage,
    resolveMarginAssistanceContactEmails,
    resolveMarginBlockedContactEmails,
    resolveMarginWarehouse,
    resolveOrderMinimumMarginPercent,
    resolveProductMarginBelowMinimum,
    resolveOrderHeaderMarginBelowMinimum,
    buildOrderMarginExceptionTooltipHtml,
    calculateOrderHeaderMarginPercent,
    showOrderMarginColumns,
    buildOrderHeaderMarginTooltip,
    formatMarginPercent,
    MarginApprovalAction,
    mapHeaderMarginFieldsFromApi,
    isMarginApprovedOnOrder,
    shouldSkipMarginProcessingGate
} from '../item-details/margin-approval.utils';
import { ItemDetailsService } from '../services/item-details.service';
import { MarginApprovalSummary, MarginValidationService } from '../services/margin-validation.service';
import { InMemoryStorageService } from '../services/in-memory-storage.service';
import { environment } from '../../environments/environment';
import { UserService } from '../pages/service/user.service';
import { CalendarModule } from 'primeng/calendar';
import { DatePickerModule } from 'primeng/datepicker';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinner } from 'primeng/progressspinner';
import { LoaderService } from '../services/loader.service';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SidebarModule } from 'primeng/sidebar';
import {
    isCopyCurrencyMismatch,
    resolveNumericCustomerId,
    TargetCustomerSnapshot
} from '../item-details-v2/services/copy-order-different-customer.util';
// In imports array:

import { ArStatementFormComponent } from '../shared/ar-statement-form/ar-statement-form.component';
import { PrePostWizardResult, PrepostTextWizardComponent } from '../shared/prepost-text-wizard/prepost-text-wizard.component';
import { TimeAgoPipe } from '../time-ago.pipe'; 
import { InvoiceRuleService } from '../services/invoice-rule.service';
import { RulesService } from '../services/rules.service';
// import {pFrozenColumn} from

interface Column {
    field: string;
    header: string;
    customExportHeader?: string;
}

interface ExportColumn {
    title: string;
    dataKey: string;
}

@Component({
    selector: 'app-crud',
    standalone: true,
    imports: [
        DropdownModule,
        MultiSelectModule,
        AutoCompleteModule,
        CalendarModule,
        DatePickerModule,
        RouterModule,
        CommonModule,
        TableModule,
        FormsModule,
        CheckboxModule,
        ButtonModule,
        ContextMenuModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule,
        TooltipModule,
        InputSwitchModule,
        RadioButtonModule,
        SidebarModule,
        ArStatementFormComponent ,
        PrepostTextWizardComponent,
        TimeAgoPipe,
        BadgeModule,
        CreditLimitDialogContentComponent,
        MarginApprovalDialogContentComponent
    ],
    templateUrl: './orderdetails.component.html',
    styleUrls: ['./orderdetails.component.css'],
    providers: [MessageService, ProductService, ConfirmationService]
})
export class OrderdetailsComponent implements OnInit, OnDestroy {
    loading: boolean | undefined;
    private readonly bottomThresholdPx = 40;
    private lastScrollTop = 0;
    private isFetchingOrderHeaders = false;

    onTableScroll(event: any): void {
        // Do not load more when showing search / filter result sets (would mix with paginated list)
        if (
            this.isShowingGlobalSearchResults ||
            this.isShowingUserResponsibleFilterResults ||
            this.isShowingDeliverySearchResults
        ) {
            return;
        }
        const scrollableView = event?.target as HTMLElement;
        if (!scrollableView) return;

        const scrollTop = scrollableView.scrollTop;
        const scrollHeight = scrollableView.scrollHeight;
        const clientHeight = scrollableView.clientHeight;
        const isScrollingDown = scrollTop > this.lastScrollTop;
        this.lastScrollTop = scrollTop;

        const isNearBottom = scrollTop + clientHeight >= scrollHeight - this.bottomThresholdPx;
        if (!isNearBottom) return;

        // Keep old vertical behavior, only ignore horizontal/no-downward events.
        if (!isScrollingDown || this.isFetchingOrderHeaders) return;
        if (this.products().length >= this.totalElements) return;

        const nextPage = this.currentPage + 1;
        this.loadOrderHeaders(nextPage, this.pageSize, '', 'DESC', {});
    }

    addresses: { label: string; addressId: any; full: any }[] = [];
    filteredAddresses: { label: string; addressId: any; full: any }[] = [];
    todayStr: string | number | undefined;
    userDivision!: string | null;
    immediateDivisions: string[] = [];
    afterCutoverDivisions: string[] = [];
    onWarehouseSelect($event: AutoCompleteSelectEvent) {
        this.loaderService.show('Loading Warehouse details...', 'Please wait...');

        console.log('Warehouse selected:', $event.value);
        const selectedWarehouse = $event.value;
        this.selectedWarehouseCountryCode = selectedWarehouse?.cscd || '';
        console.log('Selected warehouse country code:', this.selectedWarehouseCountryCode);
        this.calculateVatPercentage();
        setTimeout(() => {
            this.loaderService.hide();
        }, 100);
    }
    onFacilitySelect($event: AutoCompleteSelectEvent) {
        throw new Error('Method not implemented.');
    }

    statusHelpDialog: boolean = false; // <-- Add this line
    sidebarVisible2: boolean = false;
    errorSidebarMessage: string = '';
    @HostListener('window:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (this.draftDialogVisible) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        this.isReadOnly = this.roleAccessService.isReadOnly(this.userRoles);
        if (this.isReadOnly && event.altKey && ['n', 'N', 'r', 'R', 's', 'S'].includes(event.key)) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (event.altKey && (event.key === 'n' || event.key === 'N')) {
            event.preventDefault();
            this.openNew();
        }
        if (event.altKey && (event.key === 'r' || event.key === 'R') && this.division === '400') {
            event.preventDefault();
            this.openRouteWisePickingList();
        }
     
        if (event.altKey && (event.key === 'a' || event.key === 'A') && this.isManagerOrSuperUser) {
            event.preventDefault();
            this.openARStatementDialog();
        }
    }
    openRouteWisePickingList() {
        this.router.navigate(['/customize-picking-list']);
    }
    onAddressSelect($event: AutoCompleteSelectEvent) {
        // Ensure product is initialized
        if (!this.product) {
            this.product = {} as Product;
        }
        // Assuming $event contains the address object from the API
        console.log('Address selected:', $event.value);

        const address = $event.value;
        const addressId = address.addressId;
        const addressName = [address.addressLine1, address.addressLine2, address.addressLine3, address.addressLine4].filter(Boolean).join(', ');
        if (addressId && addressName) {
            localStorage.setItem(addressId, addressName);
            this.product.addressId = addressId;
            this.product.address = addressName;
            console.log(`Stored addressId: ${addressId}, addressName: ${addressName} in localStorage`);
            console.log('Assigned addressId to product:', this.product.addressId);
        } else {
            console.warn('Address ID or Name is missing, cannot store in localStorage');
            // Clear addressId if not valid
            this.product.addressId = '';
        }
        // ...existing code for handling address selection...
    }
    salesManagement() {
        this.router.navigate(['/dashboard']);
    }
    isFocused: boolean = false;

    productDialog: boolean = false;
    selectedProduct!: Product;
    contextMenuItems!: MenuItem[];
    isPicklistButtonVisible: boolean = false;
    // @ViewChild(AppTopbar) appTopBar!: AppTopbar;

    // products = signal<Product[]>([]);
    product: Product = {} as Product;

    selectedProducts: Product[] | null = null;

    //  products: Product[] = [];

    products = signal<Product[]>([]);
    submitted: boolean = false;

    @ViewChild('cm') cm!: ContextMenu;

    statuses!: any[];

    @ViewChild('dt') dt!: Table;
    @ViewChild('copyOrderInput') copyOrderInputRef?: ElementRef<HTMLInputElement>;

    exportColumns!: ExportColumn[];

    cols!: Column[];
    customers: string[] = [];
    filteredCustomers: string[] = [];
    facilities: any[] = [];
    warehouses: any[] = [];
    today = new Date().toISOString().slice(0, 10);
    // addresses: string[] = [];
    // filteredAddresses: string[] = [];
    filteredStatuses: string[] = [];

    categories: string[] = []; // facility
    orderType: any[] = [];

    filteredCategories: string[] = [];
    lastRefreshTime: Date | null = null;
    filteredFacilities: string[] = [];
    filteredOrderType: string[] = [];
    filteredWarehouses: string[] = [];
    customerSuggestions: unknown;
    selectedCustomer: any;
    selectedCustomerNumber: any;
    customerOptions: any;
    searchLocalException = false; 
    customerNumberOptions: any;
    selectedCustomerDetails: any = null;
    facilityLoading = false;
    warehouseLoading = false;
    orderTypeLoading = false;
    @ViewChild('proceedButton') proceedButton!: ElementRef;
    private destroy$ = new Subject<void>();
    globalSearchTerm: string = '';
    private globalSearch$ = new Subject<string>();
    /** Dedicated M3 delivery number (DLIX) search — separate from global search. */
    deliverySearchTerm: string = '';
    private deliverySearch$ = new Subject<string>();
    salesPersonFilterOptions: { label: string; value: string }[] = [];
    private salesPersonBaseOptions: { label: string; value: string }[] = [];
    /** Single salesperson selected in User Resp column filter (server-side). */
    selectedUserResponsible: string | null = null;
    private userResponsibleFilter$ = new Subject<string | null>();
    private isShowingUserResponsibleFilterResults = false;
    constructor(
        private router: Router,
        private productService: ProductService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private http: HttpClient,
        private orderDraftService: OrderDraftService,
        private inMemoryStorage: InMemoryStorageService,
        private loaderService: LoaderService,
        private roleAccessService: RoleAccessService,
        private invoiceRuleService: InvoiceRuleService,
        private rulesService: RulesService,
        public userService: UserService,
        public arStatementService: ArStatementService,
        private itemDetailsService: ItemDetailsService,
        private marginValidationService: MarginValidationService
    ) {
        this.setupCustomerSearch();
        this.setupGlobalOrderSearch();
        this.setupDeliveryNumberSearch();
        this.setupUserResponsibleFilter();
    }
    confirmInvoiceDialogVisible = false;
    item: any;
    cancelOrderDialogVisible = false;
    deleteStatus15DialogVisible = false;
    orderToDeleteStatus15: Product | null = null;
    status15CreatedInOis300 = false;
    status15Ois300OrderNumber = '';
    status15CancelDialogMessage = '';
    cancellationReasonDialogVisible = false;
    cancellationReason: string = '';
    orderToCancel: Product | null = null;
    selectedProductForInvoice: Product | null = null;

    selectedOrderNumber: string = '';
    selectedCustomerName: string = '';
    copyFromOrderNumber: string = '';
    copyOptionsDialogVisible: boolean = false;
    copyModeSelection: string = 'ALL';
    /** V2-only: copy lines/header logistics to a different customer. */
    copyToDifferentCustomer = false;
    copyTargetCustomerName: any = null;
    copyTargetCustomerNumber: any = null;
    copyTargetCustomerOptions: any[] = [];
    copyTargetCustomerNumberOptions: any[] = [];
    copyTargetCustomerId = '';
    copyTargetCustomerSnapshot: TargetCustomerSnapshot | null = null;
    copyTargetAddresses: { label: string; addressId: any; full: any }[] = [];
    copyTargetFilteredAddresses: { label: string; addressId: any; full: any }[] = [];
    copyTargetSelectedAddress: any = null;
    copyTargetAddressText = '';
    copyTargetDetailsLoading = false;
    copyTargetBlcd: string | null = null;
    copyTargetBlockWarningDialogVisible = false;
    copyTargetBlockWarningMessage = '';
    private copyTargetBlockWarningAcknowledged = false;
    copyConfirmLoading = false;

    exportPdfDialogVisible = false;
    sendOrderConfirmationMailVisible = false;
    sendOrderConfirmationMailTo = '';
    sendOrderConfirmationMailLoading = false;
    sendOrderConfirmationMailOrderNumber = '';
    orderConfirmationMailHasCustomerEmail = false;
    exportFromDate: string = this.getTodayDate();
    exportToDate: string = this.getTodayDate();
    exportPdfLoading = false;
    customerDialogVisible = false;

    showTextWizardDialog = false;
    selectedTextType: string = '';

isLoadingAR = false;

handleARSubmit(payload: {
  payerFrom: string;
  payerTo: string;
  accountingDateFrom: string;
  accountingDateTo: string;

}) {
  console.info('[ORDER] AR submit received', payload);

  this.loaderService.show('Generating AR Statement', 'Please wait...');
  this.isLoadingAR = true;

  this.arStatementService.generate({
    ...payload,
    company: this.userService.getCompanyId(),
    division: this.userService.getDivisionId(),
    warehouse: this.product?.warehouseId || this.inMemoryStorage.get('warehouseId') || ''
  }).subscribe({
    next: () => {
      this.loaderService.hide();
      this.isLoadingAR = false;
      this.customerDialogVisible = false;

      this.messageService.add({
        severity: 'success',
        summary: 'AR Statement Requested',
        detail: 'The AR statement will be sent to your registered email within a few minutes.'
      });
    },
    error: (err) => {
      this.loaderService.hide();
      this.isLoadingAR = false;

      console.error('[ORDER] AR API failed', err);

      this.messageService.add({
        severity: 'error',
        summary: 'Request Failed',
        detail: 'Unable to generate the AR statement. Please try again later.'
      });
    }
  });
}
 openARStatementDialog() {
    console.log("opened  customerDialogVisible:->",this.customerDialogVisible);
    
        this.customerDialogVisible = true;
    }

    openErrorSidebar(product: Product) {
        this.errorSidebarMessage = product.errorMessage || product.errorMessages || 'Error in the order line after validation';
        this.sidebarVisible2 = true;
    }

    openExportPdfDialog() {
        this.exportFromDate = this.getTodayDate();
        this.exportToDate = this.getTodayDate();
        this.exportDateType = 'orderCreated';
        this.exportPdfDialogVisible = true;
    }
    // onExportPdf() {
    //     if (new Date(this.exportToDate) > new Date(this.getTodayDate())) {
    //         this.messageService.add({
    //             severity: 'error',
    //             summary: 'Invalid Date',
    //             detail: 'To Date cannot exceed today.'
    //         });
    //         return;
    //     }
    //     this.exportPdfLoading = true;
    //     const company = this.inMemoryStorage.get('company') || '781';
    //     const division = this.inMemoryStorage.get('division') || '400';
    //     const apiUrl = `${environment.apiUrl}api/excel-export/orders?company=${company}&division=${division}&fromDate=${this.exportFromDate}&toDate=${this.exportToDate}`;
    //     this.http.get(apiUrl, { responseType: 'blob' }).subscribe({
    //         next: (blob) => {
    //             this.exportPdfLoading = false;
    //             const url = window.URL.createObjectURL(blob);
    //             const a = document.createElement('a');
    //             a.href = url;
    //             a.download = `orders_${this.exportFromDate}_${this.exportToDate}.xlsx`; // <-- Change to .xlsx
    //             a.click();
    //             window.URL.revokeObjectURL(url);
    //             this.exportPdfDialogVisible = false;
    //             this.messageService.add({
    //                 severity: 'success',
    //                 summary: 'Export Successful',
    //                 detail: 'Excel exported successfully.'
    //             });
    //         },
    //         error: (err) => {
    //             this.exportPdfLoading = false;
    //             this.messageService.add({
    //                 severity: 'error',
    //                 summary: 'Export Failed',
    //                 detail: 'Failed to export PDF.'
    //             });
    //         }
    //     });
    // }

    exportExportType: string = 'lines';
    exportDateType: 'orderCreated' | 'invoiceDate' = 'orderCreated';
    selectedYear: number = new Date().getFullYear();
    selectedMonth: number = new Date().getMonth();
    selectedMonthName: string = '';
    monthExportLoading = false;
    customExportLoading = false;

    updateMonthInfo() {
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        this.selectedMonthName = monthNames[this.selectedMonth];
    }

    previousMonth() {
        if (this.selectedMonth === 0) {
            this.selectedMonth = 11;
            this.selectedYear--;
        } else {
            this.selectedMonth--;
        }

        if (this.selectedYear < 2025) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Invalid Month',
                detail: 'No data available before 2025.'
            });
            this.selectedYear = 2025;
            this.selectedMonth = 0; // January 2025
        }

        this.updateMonthInfo();
    }

    nextMonth() {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth();

        // prevent future months
        if (this.selectedYear > currentYear || (this.selectedYear === currentYear && this.selectedMonth >= currentMonth)) {
            return;
        }

        if (this.selectedMonth === 11) {
            this.selectedMonth = 0;
            this.selectedYear++;
        } else {
            this.selectedMonth++;
        }
        this.updateMonthInfo();
    }

    formatDate(date: Date): string {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    }

    onExportPdf() {
        if (!this.exportFromDate || !this.exportToDate) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Missing Dates',
                detail: 'Please select both From and To dates.'
            });
            return;
        }

        const from = new Date(this.exportFromDate);
        const to = new Date(this.exportToDate);

        if (from > to) {
            this.messageService.add({
                severity: 'error',
                summary: 'Invalid Range',
                detail: 'From Date cannot be after To Date.'
            });
            return;
        }

        const diffDays = (to.getTime() - from.getTime()) / (1000 * 3600 * 24);
        if (diffDays > 31) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Range Too Large',
                detail: 'Please select a date range of 31 days or less.'
            });
            return;
        }

        this.customExportLoading = true;
        this.triggerExport(this.exportFromDate, this.exportToDate, 'custom');
    }

    onMonthExport() {
        const fromDate = new Date(this.selectedYear, this.selectedMonth, 1);
        let toDate = new Date(this.selectedYear, this.selectedMonth + 1, 0);
        const today = new Date();
        if (toDate > today) toDate = today;

        const from = this.formatDate(fromDate);
        const to = this.formatDate(toDate);

        this.monthExportLoading = true;
        this.triggerExport(from, to, 'month');
    }

    triggerExport(from: string, to: string, mode: 'month' | 'custom') {
        try {
            if (new Date(to) > new Date(this.getTodayDate())) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Invalid Date',
                    detail: 'To Date cannot exceed today.'
                });
                this.resetExportLoaders();
                return;
            }

            const company = this.inMemoryStorage.get('company') || '781';
            const division = this.inMemoryStorage.get('division') || '400';
            const exportType = this.exportExportType || 'lines';
            const dateType = this.exportDateType || 'orderCreated';
            const invSuffix = dateType === 'invoiceDate' ? '_INV' : '';

            let exportObservable;
            let filename;

            if (exportType === 'lines') {
                exportObservable = this.productService.exportOrderHeadersWithLines(company, division, from, to, dateType);
                filename = `orders_with_lines${invSuffix}_${from}_${to}.xlsx`;
            } else {
                exportObservable = this.productService.exportOrderHeaders(company, division, from, to, dateType);
                filename = `orders_headers${invSuffix}_${from}_${to}.xlsx`;
            }

            exportObservable.pipe(take(1)).subscribe({
                next: (response: Blob) => {
                    const blob = new Blob([response], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    this.messageService.add({
                        severity: 'success',
                        summary: 'Export Successful',
                        detail: `File ${filename} downloaded successfully.`
                    });

                    this.resetExportLoaders();
                },
                error: (err) => {
                    let msg: string;
                    if (err.status === 504) {
                        msg = 'Export timed out. Try a smaller date range.';
                    } else if (err.status === 500) {
                        msg = 'Export failed due to excessive data volume. Please reduce the date range (max 31 days recommended).';
                    } else if (err.status === 404) {
                        msg = 'No data found for the selected range.';
                    } else {
                        msg = 'Unexpected server error occurred during export.';
                    }

                    this.messageService.add({
                        severity: 'error',
                        summary: 'Export Failed',
                        detail: msg
                    });
                    this.resetExportLoaders();
                }
            });
        } catch (e) {
            console.error('Export failed:', e);
            this.messageService.add({
                severity: 'error',
                summary: 'Unexpected Error',
                detail: 'Something went wrong during export.'
            });
            this.resetExportLoaders();
        }
    }

    resetExportLoaders() {
        this.monthExportLoading = false;
        this.customExportLoading = false;
    }

    getTodayDate(): string {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`; // 'YYYY-MM-DD'
    }

    openPickingList(orderNumber: string, customerName: string) {
        if (!this.showPicklistColumn) {
            return;
        }
        this.item = { orderNumber: orderNumber, customerName: customerName };
        const companyId = this.inMemoryStorage.get('company') || '';
        const divisionId = this.inMemoryStorage.get('division') || '';
        const currentUsername = this.userService.getUserName();

        const product = this.products().find((p) => p.orderNumber === orderNumber);

        // Division 300: picklist accessible to everyone — skip credit/margin gates.
        // Gate: synced to M3 + both Hi and Lo status >= 44 (e.g. 44/44; 24/44 blocked).
        if (this.isDivision300()) {
            if (!this.isFrancePicklistStatusReady(product)) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Picklist not available',
                    detail: this.getFrancePicklistNotReadyMessage(product),
                    life: 6000
                });
                return;
            }
            this.proceedToPickingList(orderNumber, customerName, companyId, divisionId, currentUsername);
            return;
        }

        if (shouldSkipCreditLimitOnPicklist(divisionId) || !isCreditLimitCheckEnabledForDivision(divisionId)) {
            this.finalizePicklistNavigation(orderNumber, customerName, companyId, divisionId, currentUsername, product);
            return;
        }

        if (shouldSkipCreditLimitCheck(product?.referenceOrderId)) {
            this.finalizePicklistNavigation(orderNumber, customerName, companyId, divisionId, currentUsername, product);
            return;
        }

        this.loaderService.show('Checking credit limit...', 'Please wait...');
        const url = `${environment.apiUrl}InvoiceAndPicklist/generateOutput?companyId=${companyId}&divisionId=${divisionId}&orderNumber=${orderNumber}&orderMovingStatus=PREVIEW`;
        this.http.get<any>(url).subscribe({
            next: (data) => {
                this.loaderService.hide();
                if (shouldSkipCreditLimitCheck(resolveReferenceOrderIdFromGenerateOutput(data))) {
                    this.finalizePicklistNavigation(orderNumber, customerName, companyId, divisionId, currentUsername, product);
                    return;
                }
                const restriction = resolveCreditRestrictionFromGenerateOutput(data);
                if (isCreditRestrictionActive(restriction)) {
                    logCreditLimitBypassDebug('openPickingList', divisionId, this.inMemoryStorage, 'picklist');
                    const bypass = isCreditLimitSoftBypassUser(resolveUserEmail(this.inMemoryStorage), divisionId, 'picklist');
                    if (bypass) {
                        this.showCreditLimitProceedDialogForSync(
                            restriction,
                            () =>
                                this.finalizePicklistNavigation(
                                    orderNumber,
                                    customerName,
                                    companyId,
                                    divisionId,
                                    currentUsername,
                                    product,
                                    true
                                ),
                            'Continue to Picking List'
                        );
                        return;
                    }
                    this.showCreditLimitBlockedDialog(restriction, 'picklist');
                    return;
                }
                this.finalizePicklistNavigation(orderNumber, customerName, companyId, divisionId, currentUsername, product);
            },
            error: (err) => {
                this.loaderService.hide();
                const msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not verify credit limit.';
                this.messageService.add({ severity: 'error', summary: 'Credit Check Failed', detail: msg, life: 4000 });
            }
        });
    }

    private finalizePicklistNavigation(
        orderNumber: string,
        customerName: string,
        companyId: string,
        divisionId: string,
        currentUsername: string,
        product: Product | undefined,
        creditLimitAcknowledged = false
    ): void {
        this.checkMarginApprovalBeforeProceed(
            orderNumber,
            companyId,
            divisionId,
            product,
            'picklist',
            'Continue to Picking List',
            (marginApprovalAcknowledged) =>
                this.proceedToPickingList(
                    orderNumber,
                    customerName,
                    companyId,
                    divisionId,
                    currentUsername,
                    creditLimitAcknowledged,
                    marginApprovalAcknowledged
                )
        );
    }

    private proceedToPickingList(
        orderNumber: string,
        customerName: string,
        companyId: string,
        divisionId: string,
        currentUsername: string,
        creditLimitAcknowledged = false,
        marginApprovalAcknowledged = false
    ): void {
        const product = this.products().find((p) => p.orderNumber === orderNumber);
        // referenceOrderId + M3 Hi/Lo status + warehouse for France IDM Ruestliste / Process Picklist.
        this.item = {
            orderNumber,
            customerName,
            companyId,
            divisionId,
            referenceOrderId: product?.referenceOrderId ?? '',
            m3HighestStatus: product?.m3HighestStatus ?? '',
            m3LowestStatus: product?.m3LowestStatus ?? '',
            warehouseId: product?.warehouseId || this.inMemoryStorage.get('warehouseId') || ''
        };
        this.productService.acquireOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
            next: (res: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Lock Acquired',
                    detail: res?.message || 'Order is now locked for editing.',
                    life: 2000
                });
                this.router.navigate(['/picking-list'], {
                    state: { item: this.item, creditLimitAcknowledged, marginApprovalAcknowledged }
                });
            },
            error: (err) => {
                const msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not acquire lock.';
                this.messageService.add({ severity: 'warn', summary: 'Order Already Locked', detail: msg, life: 4000 });
            }
        });
    }
    generateInvoice(orderNumber: string, customerName: string) {
        // Find the product to check if it's cancelled
        const product = this.products().find((p) => p.orderNumber === orderNumber);
        if (product) {
            // Check if order is cancelled: status 90 and moving status CAN
            if (product.status === 90 && product.orderMovingStatus?.toUpperCase() === 'CAN') {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Cannot Generate Invoice',
                    detail: 'Invoice cannot be generated for cancelled orders.',
                    life: 3000
                });
                return;
            }
            if (product.orderMovingStatus?.toUpperCase() === 'CAN') {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Cannot Generate Invoice',
                    detail: 'Invoice cannot be generated for cancelled orders.',
                    life: 3000
                });
                return;
            }
        }

        this.item = { orderNumber: orderNumber, customerName: customerName };
        const companyId = this.inMemoryStorage.get('company') || '';
        const divisionId = this.inMemoryStorage.get('division') || '';
        const currentUsername = this.userService.getUserName();
        console.log('Opening Picking List');

        console.log('Navigating to Picking List', orderNumber);
        // this.router.navigate(['/picking-list'], {
        //     state: { item: this.item }
        // });

        this.productService.acquireOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
            next: (res: any) => {
                this.messageService.add({ severity: 'success', summary: 'Lock Acquired', detail: res?.message || 'Order is now locked for editing.', life: 2000 });
                this.router.navigate(['/generate-invoice'], {
                    state: { item: this.item }
                });
            },
            error: (err) => {
                let msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not acquire lock.';
                this.messageService.add({ severity: 'warn', summary: 'Order Already Locked', detail: msg, life: 4000 });
            }
        });
    }
    showInvoiceConfirm(orderNumber: string, orderMovingStatus: string, customerName: string) {
        console.log(orderMovingStatus);
        this.selectedOrderNumber = orderNumber;
        this.selectedCustomerName = customerName;
        const product = this.products().find((p) => p.orderNumber === orderNumber);
        this.selectedProductForInvoice = product || null;

        const movingStatus = product?.orderMovingStatus || orderMovingStatus;
        const status = product?.status;
        if (status === 90 && (movingStatus?.toUpperCase() === 'CAN' || movingStatus === 'CAN')) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Cannot Generate Invoice',
                detail: 'Invoice cannot be generated for cancelled orders.',
                life: 3000
            });
            return;
        }
        if (movingStatus?.toUpperCase() === 'CAN' || movingStatus === 'CAN') {
            this.messageService.add({
                severity: 'warn',
                summary: 'Cannot Generate Invoice',
                detail: 'Invoice cannot be generated for cancelled orders.',
                life: 3000
            });
            return;
        }

        // If already invoiced, go directly to generate-invoice (no preview)
        if (orderMovingStatus === 'INV') {
            this.generateInvoice(orderNumber, customerName);
            return;
        }

        if (this.invoiceRuleService.canViewOrderConfirmation(product)) {
            this.navigateToViewOnlyPreview(product);
            return;
        }

        if (!product && orderMovingStatus?.toUpperCase() === 'WIP') {
            this.navigateToViewOnlyPreview({
                orderNumber,
                customerName,
                orderMovingStatus,
                status: 20
            });
            return;
        }

        // Otherwise go to preview first (confirmation will be in generate-invoice)
        this.navigateToInvoicePreview();
    }

    navigateToViewOnlyPreview(product: any) {
        const item = {
            ...product,
            orderNumber: product?.orderNumber,
            customerName: product?.customerName
        };
        this.router.navigate(['/preview-invoice'], {
            state: { item, isPreview: true, fromSync: false, viewOnly: true, skipLock: true }
        });
    }

    openTextWizardDialog(textType: string) {
        this.selectedTextType = textType;
        this.showTextWizardDialog = true;
    }

    onPrePostComplete(result: PrePostWizardResult) {
        this.showTextWizardDialog = false;
        this.messageService.add({
            severity: 'success',
            summary: 'Text configured',
            detail: `${result.textType} saved for ${result.targets.length} document(s).`,
            life: 3000
        });
        console.log('Text wizard results', result);
    }

    navigateToInvoicePreview() {
        const orderNumber = this.selectedOrderNumber;
        const customerName = this.selectedCustomerName;
        const product = this.selectedProductForInvoice;
        if (!orderNumber || !customerName) {
            return;
        }
        const item = product
            ? { ...product, orderNumber, customerName: product.customerName ?? customerName }
            : { orderNumber, customerName };
        const companyId = this.inMemoryStorage.get('company') || '';
        const divisionId = this.inMemoryStorage.get('division') || '';
        const currentUsername = this.userService.getUserName();

        this.productService.acquireOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
            next: (res: any) => {
                this.messageService.add({ severity: 'success', summary: 'Lock Acquired', detail: res?.message || 'Order is now locked for editing.', life: 2000 });
                this.router.navigate(['/generate-invoice'], {
                    state: { item, isPreview: true }
                });
            },
            error: (err) => {
                const msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not acquire lock.';
                this.messageService.add({ severity: 'warn', summary: 'Order Already Locked', detail: msg, life: 4000 });
            }
        });
    }
    /**
     * Navigate to preview invoice page for Sync to M3 flow.
     * User will click "Sync to M3" on that page to sync the order.
     */
    navigateToSyncPreview(product: any) {
        const orderNumber = product?.orderNumber;
        const customerName = product?.customerName ?? '';
        if (!orderNumber) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Order number missing',
                detail: 'Cannot open preview for sync.',
                life: 4000
            });
            return;
        }
        this.selectedOrderNumber = orderNumber;
        this.selectedCustomerName = customerName;
        this.selectedProductForInvoice = product;

        const item = { ...product, orderNumber, customerName: product.customerName ?? customerName };
        const companyId = this.inMemoryStorage.get('company') || '';
        const divisionId = this.inMemoryStorage.get('division') || '';
        const currentUsername = this.userService.getUserName();

        if (!isCreditLimitCheckEnabledForDivision(divisionId)) {
            this.finalizeSyncPreviewNavigation(orderNumber, item, companyId, divisionId, currentUsername, product);
            return;
        }

        if (shouldSkipCreditLimitProcessingGate(product.referenceOrderId, product)) {
            this.finalizeSyncPreviewNavigation(orderNumber, item, companyId, divisionId, currentUsername, product);
            return;
        }

        this.loaderService.show('Checking credit limit...', 'Please wait...');
        const url = `${environment.apiUrl}InvoiceAndPicklist/generateOutput?companyId=${companyId}&divisionId=${divisionId}&orderNumber=${orderNumber}&orderMovingStatus=PREVIEW`;
        this.http.get<any>(url).subscribe({
            next: (data) => {
                this.loaderService.hide();
                if (shouldSkipCreditLimitCheck(resolveReferenceOrderIdFromGenerateOutput(data)) ||
                    isCreditLimitApprovedOnOrder(data) ||
                    isCreditLimitApprovedOnOrder(data?.invoiceDetails) ||
                    isCreditLimitApprovedOnOrder(product)) {
                    this.finalizeSyncPreviewNavigation(orderNumber, item, companyId, divisionId, currentUsername, product);
                    return;
                }
                const restriction = resolveCreditRestrictionFromGenerateOutput(data);
                if (isCreditRestrictionActive(restriction)) {
                    logCreditLimitBypassDebug('navigateToSyncPreview', divisionId, this.inMemoryStorage, 'sync');
                    const bypass = isCreditLimitSoftBypassUser(resolveUserEmail(this.inMemoryStorage), divisionId, 'sync');
                    if (bypass) {
                        console.warn('[CreditLimitBypass] sync: continue to preview (approve on Sync to M3)');
                        this.finalizeSyncPreviewNavigation(
                            orderNumber,
                            item,
                            companyId,
                            divisionId,
                            currentUsername,
                            product,
                            false
                        );
                        return;
                    }
                    // Over limit, not on approver list: open preview; inline block runs on Sync to M3 there.
                    console.warn('[CreditLimitBypass] sync: allow preview; inline hard block on Sync to M3');
                    this.finalizeSyncPreviewNavigation(
                        orderNumber,
                        item,
                        companyId,
                        divisionId,
                        currentUsername,
                        product,
                        false
                    );
                    return;
                }
                this.finalizeSyncPreviewNavigation(orderNumber, item, companyId, divisionId, currentUsername, product);
            },
            error: (err) => {
                this.loaderService.hide();
                const msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not verify credit limit.';
                this.messageService.add({ severity: 'error', summary: 'Credit Check Failed', detail: msg, life: 4000 });
            }
        });
    }

    creditLimitBlockedDialogVisible = false;
    creditLimitProceedDialogVisible = false;
    creditLimitProceedLabel = 'Continue to Sync Preview';
    private creditLimitProceedCallback: (() => void) | null = null;
    creditLimitApprovalReason = '';
    creditLimitApprovalSubmitting = false;
    private creditLimitProceedOrderNumber = '';
    creditLimitProceedNeedsApi = false;
    creditLimitDialogKind: CreditLimitDialogKind = 'exposure';
    creditLimitDialogData: CreditLimitDialogData | null = null;
    creditLimitDialogNood = 0;
    creditLimitDialogOdud = 0;
    creditLimitContactNote = '';

    get canSubmitCreditLimitApproval(): boolean {
        return this.creditLimitApprovalReason.trim().length >= CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH;
    }

    get canSubmitMarginApproval(): boolean {
        return this.marginApprovalReason.trim().length >= CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH;
    }

    private configureCreditLimitDialog(restriction: CreditRestrictionResult): void {
        const mapped = mapCreditRestrictionToDialog(restriction);
        this.creditLimitDialogKind = mapped.kind;
        this.creditLimitDialogNood = mapped.nood;
        this.creditLimitDialogOdud = mapped.odud;
        this.creditLimitDialogData = mapped.data;
    }

    private showCreditLimitBlockedDialog(
        restriction: CreditRestrictionResult,
        bypassAction: 'picklist' | 'sync'
    ): void {
        this.configureCreditLimitDialog(restriction);
        const divisionId = this.inMemoryStorage.get('division') || '';
        this.creditLimitContactNote = getCreditLimitBypassContactNote(bypassAction, String(divisionId));
        this.creditLimitBlockedDialogVisible = true;
    }

    private showCreditLimitProceedDialogForSync(
        restriction: CreditRestrictionResult,
        onProceed: () => void,
        proceedLabel = 'Continue to Sync Preview',
        orderNumberForApproval = '',
        requireApprovalApi = false
    ): void {
        this.configureCreditLimitDialog(restriction);
        this.creditLimitProceedLabel = proceedLabel;
        this.creditLimitProceedCallback = onProceed;
        this.creditLimitProceedOrderNumber = orderNumberForApproval;
        this.creditLimitProceedNeedsApi = requireApprovalApi;
        this.creditLimitApprovalReason = '';
        this.creditLimitApprovalSubmitting = false;
        this.creditLimitProceedDialogVisible = true;
    }

    onCreditLimitProceedCancel(): void {
        this.creditLimitProceedDialogVisible = false;
        this.creditLimitProceedCallback = null;
        this.creditLimitProceedNeedsApi = false;
        this.creditLimitProceedOrderNumber = '';
        this.creditLimitApprovalReason = '';
        this.creditLimitApprovalSubmitting = false;
    }

    onCreditLimitProceedAccept(): void {
        const cb = this.creditLimitProceedCallback;
        if (this.creditLimitProceedNeedsApi) {
            if (!this.canSubmitCreditLimitApproval) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Reason required',
                    detail: `Enter at least ${CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH} characters.`,
                    life: 3000
                });
                return;
            }
            const orderNumber = this.creditLimitProceedOrderNumber;
            if (!orderNumber) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Cannot approve',
                    detail: 'Order number is missing.',
                    life: 4000
                });
                return;
            }
            this.creditLimitApprovalSubmitting = true;
            this.productService.approveCreditLimit(orderNumber, this.creditLimitApprovalReason.trim()).subscribe({
                next: (res) => {
                    this.creditLimitApprovalSubmitting = false;
                    if (res?.success === false) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Approval failed',
                            detail: res?.errorMessage || res?.message || 'Could not save credit approval.',
                            life: 5000
                        });
                        return;
                    }
                    const product = this.products().find((p) => p.orderNumber === orderNumber);
                    if (product) {
                        product.creditLimitApproved = true;
                        product.creditLimitApprovedBy = res?.creditLimitApprovedBy;
                        product.creditLimitApprovedAt = res?.creditLimitApprovedAt;
                        product.creditLimitApprovalReason =
                            res?.creditLimitApprovalReason ?? this.creditLimitApprovalReason.trim();
                    }
                    this.creditLimitProceedDialogVisible = false;
                    this.creditLimitProceedCallback = null;
                    this.creditLimitProceedNeedsApi = false;
                    this.creditLimitProceedOrderNumber = '';
                    this.creditLimitApprovalReason = '';
                    cb?.();
                },
                error: (err) => {
                    this.creditLimitApprovalSubmitting = false;
                    const msg =
                        typeof err?.error === 'string'
                            ? err.error
                            : err?.error?.errorMessage || err?.error?.message || 'Could not save credit approval.';
                    this.messageService.add({ severity: 'error', summary: 'Approval failed', detail: msg, life: 5000 });
                }
            });
            return;
        }
        this.creditLimitProceedDialogVisible = false;
        this.creditLimitProceedCallback = null;
        cb?.();
    }

    onCreditLimitBlockedDialogClose(): void {
        this.creditLimitBlockedDialogVisible = false;
    }

    get creditLimitProceedNote(): string {
        return formatCreditLimitDialogNote(
            this.creditLimitDialogKind,
            this.creditLimitDialogNood,
            this.creditLimitDialogOdud,
            this.creditLimitDialogData,
            'You may continue.'
        );
    }

    get creditLimitBlockedNote(): string {
        return formatCreditLimitDialogNote(
            this.creditLimitDialogKind,
            this.creditLimitDialogNood,
            this.creditLimitDialogOdud,
            this.creditLimitDialogData,
            '',
            this.creditLimitContactNote
        );
    }

    marginApprovalProceedDialogVisible = false;
    marginApprovalBlockedDialogVisible = false;
    marginApprovalProceedLabel = 'Continue';
    marginApprovalSummary: MarginApprovalSummary | null = null;
    marginApprovalContactNote = '';
    marginApprovalContactEmails: string[] = [];
    marginApprovalBlockedNotice = '';
    marginApprovalProceedNote = getMarginApproverProceedNote();
    marginApprovalReason = '';
    marginApprovalSubmitting = false;
    private marginApprovalProceedOrderNumber = '';
    private marginApprovalProceedCallback: (() => void) | null = null;

    private mapOrderLinesForMarginCheck(content: any[]): any[] {
        return (content || []).map((item: any) => ({
            itemNumber: item.itemNo || item.itemNumber || '',
            itemName: item.itemName || '',
            quantity: item.qty ?? item.quantity ?? 0,
            amountAfterDiscount: item.netAmount ?? item.amountAfterDiscount ?? 0,
            cost: item.cost ?? item.costPrice,
            minimumMargin: item.minimumMargin ?? item.itemMcm,
            calculatedMargin: item.calculatedMargin
        }));
    }

    private checkMarginApprovalBeforeProceed(
        orderNumber: string,
        companyId: string,
        divisionId: string,
        product: Product | undefined,
        action: MarginApprovalAction,
        proceedLabel: string,
        onProceed: (marginApprovalAcknowledged: boolean) => void
    ): void {
        if (!isMarginApprovalEnabledForDivision(divisionId)) {
            onProceed(false);
            return;
        }
        if (isCreditNoteOrder(divisionId, String(product?.orderTypeId ?? ''))) {
            onProceed(false);
            return;
        }
        if (shouldSkipMarginProcessingGate(product?.referenceOrderId, product)) {
            onProceed(false);
            return;
        }
        // Header list already includes margin snapshot; skip line fetch when no violation flagged.
        if (product && !resolveProductMarginBelowMinimum(product)) {
            onProceed(false);
            return;
        }

        this.loaderService.show('Checking contribution margin...', 'Please wait...');
        this.itemDetailsService.getOrderLines(orderNumber, companyId, divisionId).subscribe({
            next: (linesResponse: any) => {
                this.loaderService.hide();
                const itemList = this.mapOrderLinesForMarginCheck(linesResponse?.content || []);
                const orderMinimum = resolveOrderMinimumMarginPercent({
                    orderMcm: product?.orderMcm,
                    minimumOrderMargin: product?.minimumOrderMargin,
                    F1N096: product?.F1N096
                });
                const summary = buildMarginApprovalSummary(this.marginValidationService, itemList, orderMinimum);
                if (!summary.hasAnyViolation) {
                    onProceed(false);
                    return;
                }
                const warehouse = resolveMarginWarehouse({
                    warehouseId: product?.warehouseId,
                    whsId: (product as any)?.whsId,
                    warehouse: (product as any)?.warehouse,
                    storageWarehouseId: this.inMemoryStorage.get('warehouseId')
                });
                this.marginApprovalSummary = summary;
                this.marginApprovalContactNote = getMarginBypassContactNote(divisionId, warehouse, action);
                if (isMarginApprovalUserFromStorage(this.inMemoryStorage, divisionId, warehouse)) {
                    this.marginApprovalContactEmails = resolveMarginAssistanceContactEmails(divisionId, warehouse);
                    this.marginApprovalProceedLabel = proceedLabel;
                    this.marginApprovalProceedNote = getMarginApproverProceedNote(proceedLabel);
                    this.marginApprovalReason = '';
                    this.marginApprovalSubmitting = false;
                    this.marginApprovalProceedOrderNumber = orderNumber;
                    this.marginApprovalProceedCallback = () => onProceed(true);
                    this.marginApprovalProceedDialogVisible = true;
                    return;
                }
                this.marginApprovalContactEmails = resolveMarginBlockedContactEmails(
                    divisionId,
                    warehouse,
                    resolveUserEmail(this.inMemoryStorage)
                );
                this.marginApprovalBlockedNotice = getMarginBlockedApprovalNotice(action);
                this.marginApprovalBlockedDialogVisible = true;
            },
            error: () => {
                this.loaderService.hide();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Margin Check Failed',
                    detail: 'Could not load order lines for margin validation.',
                    life: 4000
                });
            }
        });
    }

    onMarginApprovalProceedCancel(): void {
        this.marginApprovalProceedDialogVisible = false;
        this.marginApprovalProceedCallback = null;
        this.marginApprovalProceedOrderNumber = '';
        this.marginApprovalReason = '';
        this.marginApprovalSubmitting = false;
    }

    onMarginApprovalProceedAccept(): void {
        const cb = this.marginApprovalProceedCallback;
        this.marginApprovalProceedDialogVisible = false;
        this.marginApprovalProceedCallback = null;
        this.marginApprovalProceedOrderNumber = '';
        this.marginApprovalReason = '';
        cb?.();
    }

    onMarginApprovalBlockedDialogDismiss(): void {
        this.marginApprovalBlockedDialogVisible = false;
    }

    onMarginApprovalBlockedDialogOk(): void {
        this.marginApprovalBlockedDialogVisible = false;
    }

    showOrderMarginWarning(product: Product | null | undefined): boolean {
        if (!product || !isMarginApprovalEnabledForDivision(this.division || this.inMemoryStorage.get('division') || '')) {
            return false;
        }
        return resolveProductMarginBelowMinimum(product);
    }

    get showOrderMarginColumns(): boolean {
        const division = this.division || this.inMemoryStorage.get('division') || '';
        const warehouse = resolveMarginWarehouse({
            storageWarehouseId: this.inMemoryStorage.get('warehouseId')
        });
        return showOrderMarginColumns(division, this.inMemoryStorage, warehouse);
    }

    getOrderMarginPercent(product: Product | null | undefined): string {
        return formatMarginPercent(calculateOrderHeaderMarginPercent(product ?? {}));
    }

    getOrderMcmPercent(product: Product | null | undefined): string {
        return formatMarginPercent(
            resolveOrderMinimumMarginPercent({
                orderMcm: product?.orderMcm,
                minimumOrderMargin: product?.minimumOrderMargin,
                F1N096: product?.F1N096
            })
        );
    }

    isOrderHeaderMarginBelow(product: Product | null | undefined): boolean {
        if (!product) {
            return false;
        }
        return resolveOrderHeaderMarginBelowMinimum(product);
    }

    getOrderHeaderMarginTooltip(product: Product | null | undefined): string {
        return buildOrderHeaderMarginTooltip(product ?? {});
    }

    hasOrderHeaderMarginValue(product: Product | null | undefined): boolean {
        return calculateOrderHeaderMarginPercent(product ?? {}) != null;
    }

    getOrderMarginWarningTooltip(product: Product | null | undefined): string {
        if (!product) {
            return '<div class="margin-exception-tooltip"><div class="margin-exception-tooltip__title">Margin Exception</div></div>';
        }
        return buildOrderMarginExceptionTooltipHtml(product);
    }

    private finalizeSyncPreviewNavigation(
        orderNumber: string,
        item: any,
        companyId: string,
        divisionId: string,
        currentUsername: string,
        product: Product,
        creditLimitAcknowledged = false
    ): void {
        this.proceedToSyncPreview(
            orderNumber,
            item,
            companyId,
            divisionId,
            currentUsername,
            creditLimitAcknowledged
        );
    }

    private proceedToSyncPreview(
        orderNumber: string,
        item: any,
        companyId: string,
        divisionId: string,
        currentUsername: string,
        creditLimitAcknowledged = false
    ): void {
        this.productService.acquireOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
            next: (res: any) => {
                this.messageService.add({ severity: 'success', summary: 'Lock Acquired', detail: res?.message || 'Order is now locked for editing.', life: 2000 });
                this.router.navigate(['/preview-invoice'], {
                    state: { item, isPreview: true, fromSync: true, creditLimitAcknowledged }
                });
            },
            error: (err) => {
                const msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not acquire lock.';
                this.messageService.add({ severity: 'warn', summary: 'Order Already Locked', detail: msg, life: 4000 });
            }
        });
    }

    exportCSV() {
        this.dt.exportCSV();
    }
    canAccess = false;
    isManagerOrSuperUser = false;
    isSalesPerson = false;
    userRoles: string[] = [];
    isReadOnly: boolean = false;
    division: string = '';
    ngOnInit() {
        this.userDivision = this.userService.getDivisionId?.() || this.inMemoryStorage.get('divisionId') || null;
        this.division = this.inMemoryStorage.get('division') || '';
        console.log('Current userDivision Order details component:', this.userDivision);
        this.showFrancePicklistSuccessToastIfPresent();

        this.immediateDivisions =
            environment.divisionsToProcessImmediately
                .split(',')
                .map(d => d.trim());
    
        this.afterCutoverDivisions =
            environment.divisionsToProcessAfterCutover
                .split(',')
                .map(d => d.trim());

        if (!this.division) {
            console.error('Division not loaded');
            return;
        }
        this.loadPicklistButtonRule();

        const saved = localStorage.getItem('lastRefreshTime');
        this.lastRefreshTime = saved ? new Date(saved) : null;
        console.log('lastRefreshTime:', this.lastRefreshTime);

        this.userRoles = JSON.parse(localStorage.getItem('roleGroup') || '[]') as UserRole[];
        console.log('UserRoles:', this.userRoles);
        // Punch UI is V2-only; clear any legacy localStorage v1 preference.
        persistItemDetailsVersion();

        this.isReadOnly = this.roleAccessService.isReadOnly(this.userRoles);
        console.log('IsReadOnly?', this.isReadOnly);
        const hasOrders = !!localStorage.getItem('orders');
        const hasOrderLines = !!localStorage.getItem('orderLines');
        const today = new Date();
        this.selectedYear = today.getFullYear();
        this.selectedMonth = today.getMonth();
        this.updateMonthInfo();

        if (hasOrders && !hasOrderLines) {
            console.log('Removing orders and orderLines from localStorage');
            localStorage.removeItem('orders');
            localStorage.removeItem('orderLines');
            localStorage.removeItem('routeParams');
            this.orderDraftService.clearDraft();
        } else if (!hasOrders && hasOrderLines) {
            console.log('Removing orderLines from localStorage');
            localStorage.removeItem('orderLines');
            localStorage.removeItem('orders');
            localStorage.removeItem('routeParams');
            this.orderDraftService.clearDraft();
        }
        console.log('today:', this.today); // Should log 'yyyy-MM-dd'
        const userRoles: UserRole[] = JSON.parse(this.inMemoryStorage.get('roleGroup') || '[]');
        this.userRoles = JSON.parse(this.inMemoryStorage.get('roleGroup') || '[]');
        this.canAccess = this.roleAccessService.hasAccess(userRoles, AppFeature.ManageOrders);
        console.log('Loaded userRoles:', this.userRoles);
        this.isManagerOrSuperUser = this.userRoles.includes('sales_manager_group') || this.userRoles.includes('admin_group');
        this.isSalesPerson = this.userRoles.includes('sales_person_group');
        console.log('isManagerOrSuperUser:', this.isManagerOrSuperUser);
        console.log('isSalesPerson:', this.isSalesPerson);

        if (!this.canAccess) {
            this.router.navigate(['/']);
            return;
        }
        this.showDraftDialogIfNeeded();
        if (this.draftDialogVisible) {
            // Stop further initialization until user interacts with the draft dialog
            return;
        }
        console.log({ ...localStorage });

        console.log(this.product);

        const customerId = 'someCustomerId'; // Replace with actual logic to get customerId
        const customerName = localStorage.getItem(customerId);

        if (customerName) {
            console.log(`Retrieved customerName: ${customerName} for customerId: ${customerId}`);
        } else {
            console.warn(`No customerName found for customerId: ${customerId}`);
        }

        this.loadOrderHeaders(0, this.pageSize);
        this.loadSalesPersonFilterOptions();
        console.log(this.product);

        setTimeout(() => {
            // localStorage.setItem('products', JSON.stringify(this.products()));
            // this.setupAutoSearch();
            console.log('data', JSON.stringify(this.products(), null, 2));
        }, 0); // slight delay to ensure products are loaded

        // Only show sync/don't sync options for divisionsToProcessAfterCutover
        const afterCutoverDivisions = (environment.divisionsToProcessAfterCutover || '').split(',').map((d) => d.trim());

        // Get division from UserService
        const currentDivision = this.userService.getDivisionId?.() || '';

        this.contextMenuItems = [
            {
                label: 'Hold from M3 Sync',
                icon: 'pi pi-times-circle',
                command: () => {
                    // Only allow for selected row with status 10
                    if (!this.selectedProduct || !this.selectedProduct.orderNumber) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'No Order Selected',
                            detail: 'Please select an order to update.',
                            life: 2000
                        });
                        return;
                    }
                    if (this.selectedProduct.status !== 10) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Invalid Status',
                            detail: 'Order status must be 10 to mark as "Hold from M3 Sync".',
                            life: 4000
                        });
                        return;
                    }
                    this.confirmationService.confirm({
                        message: 'Are you sure you want to mark this order as "Hold from M3 Sync"?',
                        header: 'Confirm Don’t Sync',
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            this.productService
                                .updateOrderHeaderStatus(this.selectedProduct.orderNumber, 9, 'CustomerOrder')
                                .pipe(takeUntil(this.destroy$))
                                .subscribe({
                                    next: () => {
                                        this.messageService.add({
                                            severity: 'success',
                                            summary: 'Order Updated',
                                            detail: 'Order marked as "Hold from M3 Sync".',
                                            life: 2000
                                        });
                                        this.refreshOrders();
                                    },
                                    error: (err) => {
                                        // Treat HTTP 200 in error as success
                                        if (err && err.status === 200) {
                                            this.messageService.add({
                                                severity: 'success',
                                                summary: 'Order Updated',
                                                detail: 'Order marked as "Hold from M3 Sync".',
                                                life: 2000
                                            });
                                            this.refreshOrders();
                                        } else {
                                            this.messageService.add({
                                                severity: 'error',
                                                summary: 'Update Failed',
                                                detail: 'Failed to update order status.',
                                                life: 3000
                                            });
                                        }
                                    }
                                });
                        }
                    });
                }
            },
            {
                label: 'Allow Sync to M3',
                icon: 'pi pi-cloud-upload',
                command: () => {
                    // Only allow for selected row with status 9
                    if (!this.selectedProduct || !this.selectedProduct.orderNumber) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'No Order Selected',
                            detail: 'Please select an order to update.',
                            life: 2000
                        });
                        return;
                    }
                    if (this.selectedProduct.status !== 9) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Invalid Status',
                            detail: 'Order status must be 9 to Allow Sync to M3.',
                            life: 2000
                        });
                        return;
                    }
                    this.confirmationService.confirm({
                        message: 'Are you sure you want to Allow Sync to M3?',
                        header: 'Confirm Allow Sync',
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            this.productService
                                .updateOrderHeaderStatus(this.selectedProduct.orderNumber, 10, 'CustomerOrder')
                                .pipe(takeUntil(this.destroy$))
                                .subscribe({
                                    next: () => {
                                        this.messageService.add({
                                            severity: 'success',
                                            summary: 'Order Synced',
                                            detail: 'Order status updated to 10 (Synced to M3).',
                                            life: 2000
                                        });
                                        this.refreshOrders();
                                    },
                                    error: (err) => {
                                        // Treat HTTP 200 in error as success
                                        if (err && err.status === 200) {
                                            this.messageService.add({
                                                severity: 'success',
                                                summary: 'Order Synced',
                                                detail: 'Order status updated to 10 (Allow Sync to M3).',
                                                life: 3000
                                            });
                                            this.refreshOrders();
                                        } else {
                                            this.messageService.add({
                                                severity: 'error',
                                                summary: 'Sync Failed',
                                                detail: 'Failed to sync order to M3.',
                                                life: 3000
                                            });
                                        }
                                    }
                                });
                        }
                    });
                }
            },
            {
                label: 'Cancel Order',
                icon: 'pi pi-times',
                command: () => {
                    if (this.selectedProduct && this.canShowDeleteStatus15Option(this.selectedProduct)) {
                        this.initiateDeleteStatus15Order();
                    } else {
                        this.initiateCancelOrder();
                    }
                }
            },
            {
                label: 'Copy this order',
                icon: 'pi pi-copy',
                command: () => {
                    if (!this.selectedProduct || !this.selectedProduct.orderNumber) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'No Order Selected',
                            detail: 'Please select an order to copy.',
                            life: 2000
                        });
                        return;
                    }
                    this.copyFromOrderNumber = this.selectedProduct.orderNumber;
                    this.openCopyOptionsDialog();
                }
            },
            {
                label: 'Status Help',
                icon: 'pi pi-question-circle',
                command: () => {
                    this.statusHelpDialog = true;
                }
            }
        ];
    }

    private navigateToSelectedItemDetails(id: string, extras: { state?: any } = {}): void {
        this.router.navigate(itemDetailsRouteCommands('v2', id), extras);
    }
    currentPage = 0;
    pageSize = 100;
    totalElements = 0;
    totalPages = 0;
    orderHeaders: any[] = [];

    //  loadOrderHeadersLazy(event: TableLazyLoadEvent) {
    //         this.loading = true;
    //         // FIX: Provided a fallback of 0 for event.first to prevent 'undefined' error.
    //         const page = Math.floor((event.first || 0) / (event.rows || this.pageSize));
    //         const sortField = event.sortField as string || '';
    //         const sortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';

    //         // FIX: Provided a fallback for event.rows to prevent 'null' or 'undefined' error.
    //         this.loadOrderHeaders(page, (event.rows || this.pageSize), sortField, sortOrder, event.filters);
    //     }
    private originalData: any[] = [];
    /** True when table is showing results from global search API; prevents scroll from loading next page (which would duplicate rows). */
    private isShowingGlobalSearchResults = false;
    /** True when table is showing delivery-number (DLIX) search results. */
    private isShowingDeliverySearchResults = false;

    /**
     * Values for `p-columnFilter type="date"`. PrimeNG FilterService `dateIs` compares
     * `value.toDateString()` to the calendar date from the DatePicker — both must be real `Date`s
     * on the same *local* calendar day. Plain `new Date('yyyy-mm-dd')` is UTC midnight and can
     * shift the local day; we normalize to local calendar date at noon.
     */
    private parseColumnDate(raw: unknown): Date | null {
        if (raw == null || raw === '') return null;
        const toLocalNoon = (d: Date): Date | null => {
            if (Number.isNaN(d.getTime())) return null;
            return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0, 0);
        };
        if (raw instanceof Date) {
            return toLocalNoon(raw);
        }
        const s = String(raw).trim();
        // Naive calendar date from API (no timezone) — interpret as local, not UTC midnight.
        const ymdOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
        if (ymdOnly) {
            const y = +ymdOnly[1];
            const m = +ymdOnly[2] - 1;
            const day = +ymdOnly[3];
            const d = new Date(y, m, day, 12, 0, 0, 0);
            return Number.isNaN(d.getTime()) ? null : d;
        }
        return toLocalNoon(new Date(s));
    }

    private mapOrderHeaderFromApi(item: any) {
        const requestedDateStr = item.requestedDate || '';
        const requestedDateObj = requestedDateStr ? new Date(requestedDateStr) : null;
        const customerName = localStorage.getItem(item.customerId);
        let addressValue = item.addressName || item.address || item.addressId || '';
        let addressNameFromStorage = '';
        if (addressValue && typeof addressValue === 'string' && /^[0-9A-Za-z]+$/.test(addressValue)) {
            addressNameFromStorage = localStorage.getItem(addressValue) || '';
        }
        if (addressNameFromStorage) {
            addressValue = addressNameFromStorage;
        }
        return {
            id: item.id || item.orderHeaderId || item.orderNumber || '',
            orderNumber: item.orderNumber || 'NOT PRESENT',
            referenceOrderId: item.referenceOrderId || '',
            customer: customerName || item.customerId || '',
            address: addressValue,
            status: item.status ?? null,
            orderType: item.orderTypeName || item.orderType || item.orderTypeId || '',
            orderTypeId: item.orderTypeId || '',
            facility: item.facilityName || item.facility || item.facilityId || '',
            warehouse: item.whsName || item.warehouse || item.whsId || '',
            warehouseId: item.warehouseId || item.whsId || item.warehouse || '',
            requestedDate: item.requestedDate || '',
            name: item.name || customerName || 'No Name Available',
            userIdResponsible: item.userIdResponsible || '',
            grossValue: item.grossValue ?? null,
            totalDiscountValue: item.totalDiscountValue ?? null,
            netAmount: item.netAmount ?? null,
            vatAmount: item.vatAmount ?? null,
            totalWeight: item.totalWeight ?? null,
            orderValue: item.orderValue ?? null,
            customerName: item.customerName || customerName || 'No Name Available',
            customerId: item.customerId || '',
            uca2: item.uca2 ?? '',
            email: (item.email || item.mail || '').trim(),
            mail: (item.email || item.mail || '').trim(),
            errorMessage: item.errorMessage || item.errorMessages || '',
            orderMovingStatus: item.orderMovingStatus || '',
            cancellationReason: item.cancellationReason || '',
            cancelledBy: item.cancelledBy || '',
            requestedDateStr,
            requestedDateObj,
            m3LowestStatus: item.m3LowestStatus || '',
            m3HighestStatus: item.m3HighestStatus || '',
            invoiceNumber: item.invoiceNumber || '',
            invoiceDate: item.invoiceDate || '',
            invoiceDateObj: this.parseColumnDate(item.invoiceDate),
            tornaOrderDate: item.tornaOrderDate || item.orderCreatedDate,
            tornaOrderDateObj: this.parseColumnDate(item.tornaOrderDate || item.orderCreatedDate),
            orderMcm: item.orderMcm != null && item.orderMcm !== '' ? Number(item.orderMcm) : undefined,
            orderCost: item.orderCost != null && item.orderCost !== '' ? Number(item.orderCost) : undefined,
            minimumOrderMargin:
                item.minimumOrderMargin != null && item.minimumOrderMargin !== '' ? Number(item.minimumOrderMargin) : undefined,
            F1N096: item.F1N096,
            ...mapHeaderMarginFieldsFromApi(item)
        };
    }

    private mapUserNamesToFilterOptions(userNames: string[]): { label: string; value: string }[] {
        return [...new Set(userNames.filter((name) => !!name && String(name).trim()))]
            .map((name) => String(name).trim())
            .sort((a, b) => a.localeCompare(b))
            .map((userName) => ({ label: userName, value: userName }));
    }

    private setSalesPersonBaseOptions(userNames: string[]): void {
        this.salesPersonBaseOptions = this.mapUserNamesToFilterOptions(userNames);
        this.refreshSalesPersonFilterOptionsFromOrders();
    }

    loadSalesPersonFilterOptions(): void {
        const divisionId = this.inMemoryStorage.get('division') || '';
        const cached = this.inMemoryStorage.get('allUsers');
        if (cached) {
            try {
                const users = JSON.parse(cached) as { userName?: string; division?: string }[];
                const names = users
                    .filter((user) => !divisionId || user.division === divisionId)
                    .map((user) => user.userName || '');
                if (names.length) {
                    this.setSalesPersonBaseOptions(names);
                    return;
                }
            } catch {
                // Fall through to API fetch.
            }
        }

        this.http
            .get<{ userName?: string; division?: string }[]>(
                `${environment.authApiUrl}users-by-role-group?roleGroupName=sales_person_group`
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    const names = (data || [])
                        .filter((user) => !divisionId || user.division === divisionId)
                        .map((user) => user.userName || '');
                    this.setSalesPersonBaseOptions(names);
                },
                error: (err) => {
                    console.error('Failed to load salesperson filter options:', err);
                    this.setSalesPersonBaseOptions([]);
                }
            });
    }

    refreshSalesPersonFilterOptionsFromOrders(): void {
        const fromOrders = (this.products() || [])
            .map((product) => product.userIdResponsible)
            .filter((name): name is string => !!name && String(name).trim() !== '');
        this.salesPersonFilterOptions = this.mapUserNamesToFilterOptions([
            ...this.salesPersonBaseOptions.map((option) => option.value),
            ...fromOrders
        ]);
    }

    loadOrderHeaders(page: number = 0, size: number = 100, sortField: string = '', sortOrder: string = 'DESC', filters: any = {}) {
        const userProfile = JSON.parse(this.inMemoryStorage.get('userProfile') || '{}');
        this.lastRefreshTime = new Date();
        this.isFetchingOrderHeaders = true;
        this.loaderService.show('Loading order Data...', 'Please wait...');
        this.productService
            .getOrderHeaders(page, size, sortOrder, 'CustomerOrder')
            .pipe(
                finalize(() => {
                    this.isFetchingOrderHeaders = false;
                    this.loaderService.hide();
                })
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (res) => {
                    this.loaderService.hide();

                    // Correctly access the nested 'content' property for the data array
                    let orderHeaders = res?.content || [];

                    // Correctly access the nested pagination properties
                    this.currentPage = res?.pageNumber;
                    this.pageSize = res?.pageSize;
                    this.totalElements = res?.totalElement;
                    this.totalPages = res?.totalPages;

                    console.log('Order headers API response:', orderHeaders);
                    if (this.isSalesPerson && !this.isManagerOrSuperUser && userProfile.userName) {
                        orderHeaders = orderHeaders.filter((item: any) => item.userIdResponsible === userProfile.userName);
                    }
                    orderHeaders = orderHeaders.map((item: any) => this.mapOrderHeaderFromApi(item));
                    console.log(orderHeaders.length, 'Order headers loaded:', orderHeaders);
                    if (page === 0) {
                        this.originalData = [...orderHeaders];
                    }
                    // For virtual scroll, create a new array representing the entire dataset
                    // and place the newly fetched page of data into its correct position.
                    const currentProducts = this.products();
                    const newProducts = [...currentProducts];
                    newProducts.length = this.totalElements; // Ensure the array is the total size

                    for (let i = 0; i < orderHeaders.length; i++) {
                        newProducts[page * size + i] = orderHeaders[i];
                    }

                    const mergedOrders = newProducts.filter((p) => p) as Product[];
                    this.products.set(mergedOrders); // Set the new sparse array
                    this.refreshSalesPersonFilterOptionsFromOrders();

                    // Keep refresh results aligned with a typed global search value.
                    if (page === 0 && this.globalSearchTerm.trim()) {
                        setTimeout(() => this.globalSearch$.next(this.globalSearchTerm.trim()), 0);
                    }

                    // Show messages only on the first load
                    if (page === 0) {
                        if (orderHeaders.length === 0) {
                            this.messageService.add({
                                severity: 'warn',
                                summary: 'No Orders Found',
                                detail: 'No order data available for the selected User.',
                                life: 2000
                            });
                        } else {
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Order Details Loaded',
                                detail: 'Order Data loaded successfully.',
                                life: 1000
                            });
                        }
                    }
                },
                error: (err) => {
                    this.loaderService.hide();
                    if (page === 0) {
                        this.products.set([]);
                    }
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to load order Data.',
                        life: 3000
                    });
                    console.error('Order headers API error:', err);
                }
            });
    }

    loaddata() {
        const userProfile = JSON.parse(this.inMemoryStorage.get('userProfile') || '{}');

        this.loaderService.show('Loading all order Data...', 'Please wait...');

        this.productService
            .getOrderHeaders(0, 10000, 'DESC', 'CustomerOrder')
            .pipe(finalize(() => this.loaderService.hide()))
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (res) => {
                    let orderHeaders = res?.content || [];
                    // pagination fallback
                    this.currentPage = res?.pageNumber || 0;
                    this.pageSize = res?.pageSize || 10000;
                    this.totalElements = res?.totalElement ?? orderHeaders.length;
                    this.totalPages = res?.totalPages ?? Math.ceil(this.totalElements / this.pageSize);

                    if (this.isSalesPerson && !this.isManagerOrSuperUser && userProfile.userName) {
                        orderHeaders = orderHeaders.filter((item: any) => item.userIdResponsible === userProfile.userName);
                    }
                    const mapped = orderHeaders.map((item: any) => this.mapOrderHeaderFromApi(item));
                    this.products.set(mapped);
                    this.originalData = [...mapped];
                    this.refreshSalesPersonFilterOptionsFromOrders();

                    this.messageService.add({
                        severity: 'success',
                        summary: 'All Orders Loaded',
                        detail: `Loaded ${mapped.length} orders.`,
                        life: 2000
                    });
                },
                error: (err) => {
                    this.loaderService.hide();
                    this.products.set([]);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to load all order Data.',
                        life: 3000
                    });
                    console.error('loaddata API error:', err);
                }
            });
    }
    onRowSelect(event: any) {
        this.selectedProduct = event.data;
        console.log('Row selected:', this.selectedProduct);
    }
/** True when current division is in divisionsToProcessImmediately (e.g. 100). Used to hide Route Wise Picking List etc. */
get isImmediateDivision(): boolean {
    const divisionId = this.userDivision ?? (this.division || '');
    return divisionId !== '' && this.immediateDivisions.includes(divisionId);
}

    /** PickList column: hidden for warehouses 101 / 110 / 130. Div 300 always shows (open to everyone). */
    get showPicklistColumn(): boolean {
        const warehouseId = String(this.inMemoryStorage.get('warehouseId') ?? '').trim();
        if (warehouseId === '101' || warehouseId === '110' || warehouseId === '130') {
            return false;
        }
        if (this.isDivision300()) {
            return true;
        }
        return this.isPicklistButtonVisible;
    }

    get showDivision100OrderColumns(): boolean {
        return (this.division || this.userService.getDivisionId?.() || '').toString().trim() === '100';
    }

    /** Label for the Sync to M3 column/action: "Cfm & Sync" for division 100, "Confirm Order and Sync" for other immediate divisions, "Sync to M3" otherwise */
    get syncToM3ColumnLabel(): string {
        const divisionId = (this.division || this.userService.getDivisionId?.() || '').toString().trim();
        if (divisionId === '100') {
            return 'Cfm & Sync';
        }
        const immediateDivisions = (environment.divisionsToProcessImmediately || '').split(',').map((d) => d.trim());
        return immediateDivisions.includes(divisionId) ? 'Confirm Order and Sync' : 'Sync to M3';
    }
    /** Used by Orders1 template for France-only picklist status gate. */
    isDivision300(): boolean {
        const divisionId = (this.division || this.userDivision || this.userService.getDivisionId?.() || '').toString().trim();
        return divisionId === '300';
    }

    /** Orders1 Delivery # search — controlled by environment.deliverySearchEnabledDivisions. */
    isDeliverySearchEnabled(): boolean {
        const divisionId = (this.division || this.userDivision || this.userService.getDivisionId?.() || '')
            .toString()
            .trim();
        if (!divisionId) {
            return false;
        }
        const enabled = String(environment.deliverySearchEnabledDivisions ?? '')
            .split(',')
            .map((d) => d.trim())
            .filter(Boolean);
        return enabled.includes(divisionId);
    }

    /** Toast after France Process/Confirm redirects back to Orders1. */
    private showFrancePicklistSuccessToastIfPresent(): void {
        let detail = '';
        try {
            detail = (sessionStorage.getItem('francePicklistSuccessToast') || '').trim();
            if (detail) {
                sessionStorage.removeItem('francePicklistSuccessToast');
            }
        } catch {
            detail = '';
        }
        if (!detail) {
            return;
        }
        setTimeout(() => {
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail,
                life: 5000
            });
        }, 0);
    }

    /**
     * France (300) Orders1: picklist enabled only when order is synced to M3
     * and both Hi and Lo statuses are >= 44 (e.g. 44/44). Mixed 24/44 is blocked.
     */
    isFrancePicklistStatusReady(product: Product | undefined | null): boolean {
        if (!product) {
            return false;
        }
        if (!this.isFranceOrderSyncedToM3(product)) {
            return false;
        }
        const hi = this.parseM3StatusNumber(product.m3HighestStatus);
        const lo = this.parseM3StatusNumber(product.m3LowestStatus);
        return hi != null && lo != null && hi >= 44 && lo >= 44;
    }

    /** Synced = has M3 ORNO and at least one of Hi/Lo status populated. */
    private isFranceOrderSyncedToM3(product: Product): boolean {
        const ref = `${product.referenceOrderId ?? ''}`.trim();
        if (!ref) {
            return false;
        }
        const hi = this.parseM3StatusNumber(product.m3HighestStatus);
        const lo = this.parseM3StatusNumber(product.m3LowestStatus);
        return hi != null || lo != null;
    }

    getPicklistButtonTooltip(product: Product): string {
        if (!this.isDivision300()) {
            return '';
        }
        if (this.isFrancePicklistStatusReady(product)) {
            return '';
        }
        return this.getFrancePicklistNotReadyMessage(product);
    }

    /** User-facing reason picklist is blocked (France). */
    private getFrancePicklistNotReadyMessage(product: Product | undefined | null): string {
        if (!product || !this.isFranceOrderSyncedToM3(product)) {
            return 'Picklist is available after the order is synced to M3.';
        }
        const hi = `${product.m3HighestStatus ?? ''}`.trim() || '—';
        const lo = `${product.m3LowestStatus ?? ''}`.trim() || '—';
        return `Picklist is available when both M3 statuses are 44 or higher (e.g. 44/44, 66/66). Current status: Lo ${lo} / Hi ${hi}. Status 24/44 is not allowed.`;
    }

    private parseM3StatusNumber(raw: unknown): number | null {
        const s = `${raw ?? ''}`.trim();
        if (!s) {
            return null;
        }
        const n = Number(s);
        return Number.isFinite(n) ? n : null;
    }

    /** Default order type after customer search / facility change: FT1 (division 300), else from API details. */
    private resolveCustomerSearchOrderTypeId(details: any): string {
        if (this.isDivision300()) {
            return 'FT1';
        }
        return details.ortp || details.ORDERTYPE || details.orderType || '';
    }
        /** Min width for Sync to M3 column */
    get syncToM3ColumnMinWidth(): string {
        if (this.syncToM3ColumnLabel === 'Confirm Order and Sync') {
            return '180px';
        }
        if (this.syncToM3ColumnLabel === 'Cfm & Sync') {
            return '140px';
        }
        return '130px';
    }
    /** Max width for Sync to M3 column */
    get syncToM3ColumnMaxWidth(): string {
        if (this.syncToM3ColumnLabel === 'Confirm Order and Sync') {
            return '220px';
        }
        if (this.syncToM3ColumnLabel === 'Cfm & Sync') {
            return '160px';
        }
        return '160px';
    }
    // onDisplay() {
    //     console.log('triggered');

    //     if (this.selectedProduct) {
    //         console.log('Selected Product:', this.selectedProduct);

    //         this.product.name = this.selectedCustomer?.CUNM || 'No Name Available';
    //         console.log('Product Name:', this.product.name); // Debugging
    //         // Try to extract addressId from address field if it's an object, or use as string
    //         let addressId = '';
    //         if (typeof this.selectedProduct.address === 'object' && this.selectedProduct.address !== null && 'addressId' in this.selectedProduct.address) {
    //             addressId = (this.selectedProduct.address as { addressId?: string }).addressId || '';
    //         } else if (typeof this.selectedProduct.address === 'string') {
    //             addressId = this.selectedProduct.address;
    //         }
    //         this.router.navigate(['/item', this.selectedProduct.id], {
    //             state: {
    //                 product: this.selectedProduct,
    //                 customerData: {
    //                     CUNO: this.selectedCustomer?.CUNO,
    //                     CUNM: this.selectedCustomer?.CUNM
    //                 },
    //                 name: this.product.name,
    //                 addressId: addressId // Pass addressId if present
    //             }
    //         });
    //         console.log(this.product.name);
    //     } else {
    //         console.warn('No product selected');
    //     }
    // }
    onDisplay(product: Product, event?: Event) {
        if (event) {
            event.preventDefault(); // Prevent default anchor navigation
        }
        this.selectedProduct = product;

        const orderNumber = product.orderNumber;
        const companyId = this.inMemoryStorage.get('company') || '';
        const divisionId = this.inMemoryStorage.get('division') || '';
        const currentUsername = this.userService.getUserName();

        this.productService.acquireOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
            next: (res: any) => {
                this.messageService.add({ severity: 'success', summary: 'Lock Acquired', detail: res?.message || 'Order is now locked for editing.', life: 3000 });
                // Now navigate to item details
                this.product.name = this.selectedCustomer?.CUNM || 'No Name Available';
                let addressId = '';
                if (typeof product.address === 'object' && product.address !== null && 'addressId' in product.address) {
                    addressId = (product.address as { addressId?: string }).addressId || '';
                } else if (typeof product.address === 'string') {
                    addressId = product.address;
                }
                this.navigateToSelectedItemDetails(String(product.id ?? product.orderNumber ?? ''), {
                    state: {
                        product: product,
                        customerData: {
                            CUNO: this.selectedCustomer?.CUNO,
                            CUNM: this.selectedCustomer?.CUNM
                        },
                        name: this.product.name,
                        addressId: addressId
                    }
                });
            },
            error: (err) => {
                let msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not acquire lock.';
                this.messageService.add({ severity: 'warn', summary: 'Order Already Locked', detail: msg, life: 4000 });
            }
        });
    }
    onUpdate() {
        if (this.selectedProduct) {
            this.router.navigate(['/update'], { state: { product: this.selectedProduct } });
        }
    }

    onDelete() {
        console.log('triggered');

        if (this.selectedProduct) {
            this.router.navigate(['/delete', this.selectedProduct.id], {
                state: { product: this.selectedProduct }
            });
        } else {
        }
    }

    onRightClick(event: MouseEvent, product: Product) {
        event.preventDefault();
        this.selectedProduct = product;

        // Dynamically filter context menu items for status 10 only
        this.cm.model = this.contextMenuItems.filter((item) => {
            if ((item.label === 'Pre-text' || item.label === 'Post-text') && (product.status === 20 || ['WIP', 'INV'].includes(product.orderMovingStatus || ''))) {
                return false;
            }
            if (item.label === 'Hold from M3 Sync' && product.status !== 10) {
                return false;
            }
            if (item.label === 'Allow Sync to M3' && product.status !== 9) {
                return false;
            }
            if (item.label === 'Cancel Order' && !this.canShowCancelOption(product) && !this.canShowDeleteStatus15Option(product)) {
                return false;
            }
            return true;
        });

        this.cm.show(event);
    }

    onRowRightClick(event: any) {
        event.preventDefault();
        this.selectedProduct = event.data;

        // Dynamically filter context menu items for status 10 only
        this.cm.model = this.contextMenuItems.filter((item) => {
            if ((item.label === 'Pre-text' || item.label === 'Post-text') && (event.data.status === 20 || ['WIP', 'INV'].includes(event.data.orderMovingStatus || ''))) {
                return false;
            }
            if ((item.label === 'Don’t sync this order to M3' || item.label === 'Sync this order to M3') && event.data.status !== 10) {
                return false;
            }
            if (item.label === 'Cancel Order' && !this.canShowCancelOption(event.data) && !this.canShowDeleteStatus15Option(event.data)) {
                return false;
            }
            return true;
        });

        this.cm.show(event.originalEvent);
    }
    initiateCancelOrder() {
        if (!this.selectedProduct) {
            this.messageService.add({
                severity: 'error',
                summary: 'No Order Selected',
                detail: 'Please select an order to cancel.',
                life: 2000
            });
            return;
        }

        this.orderToCancel = this.selectedProduct;
        this.cancelOrderDialogVisible = true;
    }

    confirmCancelOrder() {
        this.cancelOrderDialogVisible = false;
        this.cancellationReasonDialogVisible = true;
    }

    cancelCancelOrder() {
        this.cancelOrderDialogVisible = false;
        this.orderToCancel = null;
        this.cancellationReason = '';
    }

    submitCancellation() {
        if (!this.cancellationReason || this.cancellationReason.trim() === '') {
            this.messageService.add({
                severity: 'warn',
                summary: 'Cancellation Reason Required',
                detail: 'Please provide a cancellation reason.',
                life: 3000
            });
            return;
        }

        if (!this.orderToCancel || !this.orderToCancel.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Order information is missing.',
                life: 3000
            });
            return;
        }

        this.productService
            .cancelOrder(this.orderToCancel.orderNumber.toString(), this.cancellationReason.trim())
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Order Cancelled',
                        detail: 'Order has been cancelled successfully.',
                        life: 3000
                    });
                    this.cancellationReasonDialogVisible = false;
                    this.cancellationReason = '';
                    this.orderToCancel = null;
                    this.refreshOrders();
                },
                error: (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Cancellation Failed',
                        detail: err?.error?.message || 'Failed to cancel order. Please try again.',
                        life: 4000
                    });
                }
            });
    }

    closeCancellationReasonDialog() {
        this.cancellationReasonDialogVisible = false;
        this.cancellationReason = '';
        this.orderToCancel = null;
    }
    private loadPicklistButtonRule() {
        const division = this.inMemoryStorage.get('division') || this.division;
        const warehouse = this.inMemoryStorage.get('warehouseId') || '';

        this.rulesService.loadRuleScopes(division).subscribe({
            next: () => {
                this.isPicklistButtonVisible = this.rulesService.isRuleApplicable(
                    'SHOW_PICKLIST_BUTTON',
                    division,
                    warehouse
                );
            },
            error: () => {
                this.isPicklistButtonVisible = false;
            }
        });
    }
    canShowCancelOption(product: Product): boolean {
        if (!product) {
            return false;
        }
        if (product.orderMovingStatus === 'CAN' || product.orderMovingStatus === 'INV' || product.status === 20) {
            return false;
        }

        // Status 15 with no M3 reference: never created in OIS275 — local DB cancel (same as CRT)
        if (product.status === 15) {
            const referenceOrderId = (product.referenceOrderId || '').toString().trim();
            return referenceOrderId.length === 0;
        }

        // Order Status must be 10 or 9
        if (product.status !== 10 && product.status !== 9) {
            return false;
        }

        // Moving Status must be CRT or PKL
        if (product.orderMovingStatus !== 'CRT' && product.orderMovingStatus !== 'PKL') {
            return false;
        }
        return true;
    }

    canShowDeleteStatus15Option(product: Product): boolean {
        if (!product) {
            return false;
        }
        if (product.status !== 15) {
            return false;
        }
        if (product.orderMovingStatus === 'CAN') {
            return false;
        }
        const referenceOrderId = (product.referenceOrderId || '').toString().trim();
        return referenceOrderId.length > 0;
    }

    initiateDeleteStatus15Order() {
        if (!this.selectedProduct || !this.selectedProduct.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'No Order Selected',
                detail: 'Please select an order to cancel.',
                life: 2000
            });
            return;
        }

        if (!this.canShowDeleteStatus15Option(this.selectedProduct)) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Cancel Not Allowed',
                detail: 'Only status 15 orders with an M3 reference order number can be cancelled this way.',
                life: 3000
            });
            return;
        }

        const orderNumber = this.selectedProduct.orderNumber.toString();
        this.orderToDeleteStatus15 = this.selectedProduct;
        this.loaderService.show('Checking M3 order status...', 'Please wait...');

        this.productService
            .checkStatus15Ois300(orderNumber)
            .pipe(
                finalize(() => this.loaderService.hide()),
                takeUntil(this.destroy$)
            )
            .subscribe({
                next: (res) => {
                    this.status15CreatedInOis300 = !!res?.createdInOis300;
                    this.status15Ois300OrderNumber = (res?.ois300OrderNumber || '').toString().trim();
                    if (this.status15CreatedInOis300) {
                        const ois300Ref = this.status15Ois300OrderNumber
                            ? ` ${this.status15Ois300OrderNumber}`
                            : '';
                        this.status15CancelDialogMessage =
                            `Order is already created in M3 (OIS300${ois300Ref}). If you still want to delete the order, delete it in M3 — it will automatically reflect here.`;
                    } else {
                        this.status15CancelDialogMessage =
                            'This order is stuck in M3 (status 15). Cancel it from M3 and Torna?';
                    }
                    this.deleteStatus15DialogVisible = true;
                },
                error: (err) => {
                    this.orderToDeleteStatus15 = null;
                    const detail =
                        err?.error?.errorMessage ||
                        err?.error?.message ||
                        'Failed to check M3 order status. Please try again.';
                    this.messageService.add({
                        severity: 'error',
                        summary: 'M3 Check Failed',
                        detail,
                        life: 5000
                    });
                }
            });
    }

    cancelDeleteStatus15Order() {
        this.deleteStatus15DialogVisible = false;
        this.orderToDeleteStatus15 = null;
        this.status15CreatedInOis300 = false;
        this.status15Ois300OrderNumber = '';
        this.status15CancelDialogMessage = '';
    }

    confirmDeleteStatus15Order() {
        if (this.status15CreatedInOis300) {
            this.cancelDeleteStatus15Order();
            return;
        }

        if (!this.orderToDeleteStatus15?.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Order information is missing.',
                life: 3000
            });
            return;
        }

        const orderNumber = this.orderToDeleteStatus15.orderNumber.toString();
        this.deleteStatus15DialogVisible = false;
        this.loaderService.show('Cancelling order...', 'Please wait...');

        this.productService
            .deleteStatus15BatchOrder(orderNumber)
            .pipe(
                finalize(() => this.loaderService.hide()),
                takeUntil(this.destroy$)
            )
            .subscribe({
                next: (res) => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Order Cancelled',
                        detail: res?.message || 'Order cancelled successfully (stuck in M3 batch).',
                        life: 3000
                    });
                    this.orderToDeleteStatus15 = null;
                    this.status15CreatedInOis300 = false;
                    this.status15Ois300OrderNumber = '';
                    this.status15CancelDialogMessage = '';
                    this.refreshOrders();
                },
                error: (err) => {
                    const detail =
                        err?.error?.errorMessage ||
                        err?.error?.message ||
                        'Failed to cancel status 15 batch order. Please try again.';
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Cancellation Failed',
                        detail,
                        life: 5000
                    });
                    this.orderToDeleteStatus15 = null;
                    this.status15CreatedInOis300 = false;
                    this.status15Ois300OrderNumber = '';
                    this.status15CancelDialogMessage = '';
                }
            });
    }

    isOrderCancelled(product: Product): boolean {
        return product.orderMovingStatus === 'CAN';
    }
    // canGenerateInvoice(product: Product | null): boolean {
    //     if (!product) {
    //         return false;
    //     }
        
    //     const movingStatus = product?.orderMovingStatus?.toUpperCase() || '';
        
    //     // Disable invoice when moving status is WIP (syncing in progress)
    //     if (movingStatus === 'WIP') {
    //         return false;
    //     }
        
    //     // Disable invoice when status is 10 and moving status is PKL (ready to sync)
    //     if (product.status === 10 && movingStatus === 'PKL') {
    //         return false;
    //     }
        
    //     // Check if order is cancelled: status 90 and moving status CAN
    //     if (product.status === 90 && movingStatus === 'CAN') {
    //         return false;
    //     }
        
    //     if (movingStatus === 'CAN') {
    //         return false;
    //     }
    //     return true;
    // }
    canGenerateInvoice(product: Product | null): boolean {
  return this.invoiceRuleService.canGenerateInvoice(product);
    }
    
    
    confirmAndGenerateInvoice() {
        if (!this.selectedProductForInvoice) {
            return;
        }
    
        const movingStatus =
            this.selectedProductForInvoice.orderMovingStatus?.toUpperCase() || '';
    
        const isCancelled =
            this.selectedProductForInvoice.status === 90 || movingStatus === 'CAN';
    
        // 🔔 Show message ONLY for cancelled orders

        if (isCancelled) {
            console.log(this.selectedProductForInvoice);
            
            this.messageService.add({
                severity: 'warn',
                summary: 'Cannot Generate Invoice',
                detail: 'Invoice cannot be generated for cancelled orders.',
                life: 3000
            });
            return;
        }
    
        // ✅ Generate only for 20 + INV
        if (this.canGenerateInvoice(this.selectedProductForInvoice)) {
            this.confirmInvoiceDialogVisible = false;
            this.generateInvoice(this.selectedOrderNumber, this.selectedCustomerName);
        }
    }
    
    viewProduct(product: Product) {
        this.messageService.add({
            severity: 'info',
            summary: 'Product Info',
            detail: `Name: ${product.name}, Price: ${product.price}`
        });
    }

    onGlobalFilter(_table: Table, event: Event) {
        const searchTerm = (event.target as HTMLInputElement).value;
        this.globalSearchTerm = searchTerm;
        if (searchTerm.trim()) {
            this.clearDeliverySearchState(false);
        }
        this.globalSearch$.next(searchTerm);
    }

    onDeliveryNumberFilter(event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        this.deliverySearchTerm = value;
        this.deliverySearch$.next(value);
    }

    onDeliveryNumberEnter(event: Event): void {
        event.preventDefault();
        const term = (this.deliverySearchTerm || '').trim();
        this.deliverySearch$.next(term);
    }

    private resetGlobalSearchView(): void {
        this.isShowingGlobalSearchResults = false;
        this.dt?.reset();
        this.products.set([...this.originalData]);
    }

    private resetDeliverySearchView(): void {
        this.isShowingDeliverySearchResults = false;
        this.dt?.reset();
        this.products.set([...this.originalData]);
    }

    /** Clears delivery search UI state; optionally restore the default order list. */
    private clearDeliverySearchState(restoreList: boolean): void {
        this.deliverySearchTerm = '';
        if (this.isShowingDeliverySearchResults && restoreList) {
            this.resetDeliverySearchView();
        } else {
            this.isShowingDeliverySearchResults = false;
        }
    }

    private setupGlobalOrderSearch(): void {
        this.globalSearch$
            .pipe(
                map((term) => term.trim()),
                distinctUntilChanged(),
                debounce((term) => (term === '' ? timer(0) : timer(400))),
                switchMap((term) => {
                    if (term === '') {
                        this.resetGlobalSearchView();
                        return EMPTY;
                    }
                    if (term.length < 3) {
                        this.resetGlobalSearchView();
                        return EMPTY;
                    }
                    this.loaderService.show('Performing global search...', 'Please wait...');
                    return this.productService.globalSearchOrderHeaders(term).pipe(
                        map((res) => ({ term, res })),
                        catchError((err) => {
                            console.error('Global search API error:', err);
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Search Error',
                                detail: 'Failed to perform global search.'
                            });
                            this.resetGlobalSearchView();
                            return EMPTY;
                        }),
                        finalize(() => this.loaderService.hide())
                    );
                }),
                takeUntil(this.destroy$)
            )
            .subscribe(({ term, res }) => {
                const orderHeaders = (res?.content || []).map((item: any) => this.mapOrderHeaderFromApi(item));
                this.isShowingGlobalSearchResults = true;
                this.isShowingDeliverySearchResults = false;
                this.isShowingUserResponsibleFilterResults = false;
                this.selectedUserResponsible = null;
                this.products.set(orderHeaders);
                this.refreshSalesPersonFilterOptionsFromOrders();
                if (orderHeaders.length === 0) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Not Found',
                        detail: `No orders found matching "${term}".`
                    });
                } else {
                    this.messageService.add({
                        severity: 'info',
                        summary: 'Search Complete',
                        detail: `${orderHeaders.length} order(s) found.`
                    });
                }
            });
    }

    /**
     * Search Torna orders by M3 delivery number (DLIX).
     * Dedicated field — does not share the global search box.
     * Enabled when {@link isDeliverySearchEnabled} is true.
     */
    private setupDeliveryNumberSearch(): void {
        this.deliverySearch$
            .pipe(
                map((term) => term.trim()),
                distinctUntilChanged(),
                debounce((term) => (term === '' ? timer(0) : timer(400))),
                switchMap((term) => {
                    if (term === '') {
                        this.resetDeliverySearchView();
                        return EMPTY;
                    }
                    if (!this.isDeliverySearchEnabled()) {
                        return EMPTY;
                    }
                    // Clear conflicting list modes before hitting M3.
                    this.globalSearchTerm = '';
                    this.isShowingGlobalSearchResults = false;
                    this.selectedUserResponsible = null;
                    this.isShowingUserResponsibleFilterResults = false;

                    this.loaderService.show('Searching by delivery number...', 'Please wait...');
                    return this.productService.findOrdersByDeliveryNumber(term).pipe(
                        map((res) => ({ term, res })),
                        catchError((err) => {
                            console.error('Delivery number search API error:', err);
                            const detail =
                                err?.error?.message ||
                                err?.error?.error ||
                                err?.message ||
                                'Failed to search by delivery number.';
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Delivery Search Error',
                                detail
                            });
                            this.resetDeliverySearchView();
                            return EMPTY;
                        }),
                        finalize(() => this.loaderService.hide())
                    );
                }),
                takeUntil(this.destroy$)
            )
            .subscribe(({ term, res }) => {
                const orderHeaders = (res?.content || []).map((item: any) => this.mapOrderHeaderFromApi(item));
                this.isShowingDeliverySearchResults = true;
                this.isShowingGlobalSearchResults = false;
                this.isShowingUserResponsibleFilterResults = false;
                this.products.set(orderHeaders);
                this.refreshSalesPersonFilterOptionsFromOrders();
                if (orderHeaders.length === 0) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Not Found',
                        detail: `No Torna order for delivery "${term}".`
                    });
                } else {
                    this.messageService.add({
                        severity: 'info',
                        summary: 'Search Complete',
                        detail: `${orderHeaders.length} order(s) found for delivery "${term}".`
                    });
                }
            });
    }

    onUserResponsibleFilterChange(name: string | null | undefined): void {
        const value = name != null && String(name).trim() !== '' ? String(name).trim() : null;
        this.selectedUserResponsible = value;
        this.userResponsibleFilter$.next(value);
    }

    private resetUserResponsibleFilterView(): void {
        this.isShowingUserResponsibleFilterResults = false;
        if (this.globalSearchTerm.trim().length >= 3) {
            this.globalSearch$.next(this.globalSearchTerm.trim());
            return;
        }
        this.dt?.reset();
        this.products.set([...this.originalData]);
    }

    private setupUserResponsibleFilter(): void {
        this.userResponsibleFilter$
            .pipe(
                distinctUntilChanged(),
                switchMap((name) => {
                    if (!name) {
                        this.resetUserResponsibleFilterView();
                        return EMPTY;
                    }
                    this.loaderService.show('Filtering by salesperson...', 'Please wait...');
                    return this.productService.getOrderHeadersByUserResponsible(name).pipe(
                        map((res) => ({ name, res })),
                        catchError((err) => {
                            console.error('User responsible filter API error:', err);
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Filter Error',
                                detail: 'Failed to filter orders by salesperson.'
                            });
                            this.resetUserResponsibleFilterView();
                            return EMPTY;
                        }),
                        finalize(() => this.loaderService.hide())
                    );
                }),
                takeUntil(this.destroy$)
            )
            .subscribe(({ name, res }) => {
                const orderHeaders = (res?.content || []).map((item: any) => this.mapOrderHeaderFromApi(item));
                this.isShowingUserResponsibleFilterResults = true;
                this.isShowingGlobalSearchResults = false;
                this.products.set(orderHeaders);
                this.refreshSalesPersonFilterOptionsFromOrders();
                if (orderHeaders.length === 0) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Not Found',
                        detail: `No orders found for salesperson "${name}".`
                    });
                } else {
                    this.messageService.add({
                        severity: 'info',
                        summary: 'Filter Complete',
                        detail: `${orderHeaders.length} order(s) found for "${name}".`
                    });
                }
            });
    }
    openNew() {
        console.log('Opening new product dialog');
        console.log('Initial product state:', this.product);
        localStorage.removeItem('orders');
        localStorage.removeItem('orderLines');
        localStorage.removeItem('routeParams');

        setTimeout(() => {
            console.log('Focusing on customer field');
            if (this.customerField && this.customerField.inputEL) {
                console.log('Customer field found, focusing on it');

                this.customerField.inputEL.nativeElement.focus();
            }
        }, 400);
        const facilityId = this.inMemoryStorage.get('facilityId'); // Default to '1234' if not set]
        const warehouseId = this.inMemoryStorage.get('warehouseId'); // Default to '1234' if not set
        this.selectedCustomer = null;
        // Set today's date in 'yyyy-mm-dd' format for requestedDate
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        this.todayStr = `${yyyy}-${mm}-${dd}`;
        this.product = {
            name: '',
            description: '',
            inventoryStatus: '',
            category: '',
            requestedDate: this.todayStr, // <-- set today's date
            addressId: '',
            address: '',
            facilityId: facilityId,
            warehouseId: warehouseId,
            orderTypeId: '',
            quantity: 0,
            isCustom: 0,
            customAddress: ''
        } as Product;
        this.submitted = false;
        this.copyFromOrderNumber = '';
        this.productDialog = true;
        // Focus the Select Customer field after a short delay to ensure dialog is rendered
    }

    editProduct(product: any) {
        // Ensure product is initialized
        if (!product) {
            product = {} as Product;
        }
        console.log('Editing product:', product);

        const customer = product.customer; // Assuming this is the ID

        this.selectedCustomer = product.customerName;
        console.log('Selected Customer:', this.selectedCustomer);

        // Clone the product and add customerName
        this.product = {
            ...product,
            name: customer || '',
            addressId: product.addressId || '',
            facilityId: product.facilityId || product.facility || '',
            warehouseId: product.warehouseId || product.warehouse || product.whsId || '',
            orderTypeId: product.orderTypeId || product.orderType || ''
        };
        if (Number(product?.isCustom) === 1) {
            this.product.address = (product.customAddress || product.address || '') as string;
        }
        console.log('Product to edit:', this.product);

        this.productDialog = true; // Open the dialog for editing
    }

    deleteSelectedProducts() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the selected products?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.products.set(this.products().filter((val) => !this.selectedProducts?.includes(val)));
                this.selectedProducts = null;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Products Deleted',
                    life: 3000
                });
            }
        });
    }

    hideDialog() {
        this.productDialog = false;
        this.submitted = false;
        
        const preservedFacilityId = this.product.facilityId;
        const preservedWarehouseId = this.product.warehouseId;

        this.product = {
            name: '',
            description: '',
            inventoryStatus: '',
            category: '',
            requestedDate: this.todayStr,
            addressId: '',
            address: '',
            facilityId: preservedFacilityId,
            warehouseId: preservedWarehouseId,
            orderTypeId: '',
            quantity: 0,
            isCustom: 0,
            customAddress: ''
        } as Product;
        
        this.selectedCustomer = null;
        this.selectedCustomerNumber = null;
        this.addresses = [];
        this.filteredAddresses = [];
        this.categories = [];
        this.filteredCategories = [];
        this.filteredStatuses = [];
        this.orderType = [];
        this.filteredOrderType = [];
        this.copyFromOrderNumber = '';
        this.searchLocalException = false;
    }
    @ViewChild('customerField') customerField!: AutoComplete;
    @ViewChild('customerNumberField') customerNumberField!: AutoComplete;
    @ViewChild('addressField') addressField!: AutoComplete;
    @ViewChild('orderTypeField') orderTypeField!: AutoComplete;
    @ViewChild('facilityField') facilityField!: AutoComplete;
    @ViewChild('warehouseField') warehouseField!: AutoComplete;
    @ViewChild('requestedDateField') requestedDateField!: ElementRef;
    @ViewChild('submitButton') submitButton!: ElementRef;
    focusSubmitButton() {
        if (this.submitButton && this.submitButton.nativeElement) {
            this.submitButton.nativeElement.focus();
        }
    }
    focusNext(field: string) {
        const autoComplete = this[field as keyof this] as AutoComplete;
        const inputEl = autoComplete?.inputEL?.nativeElement;

        if (inputEl) {
            inputEl.focus();
        }
    }

    focusAddressInput() {
        const input = this.addressField?.el?.nativeElement?.querySelector('input');
        if (input) {
            input.focus();
        }
    }

    /** When user types, drop list selection if text no longer matches the selected master address */
    onAddressInput(value: string | { label?: string; addressId?: string; full?: unknown } | null): void {
        if (value != null && typeof value === 'object' && 'label' in value) {
            return;
        }
        const text = typeof value === 'string' ? value.trim() : '';
        const idMatch = this.product.addressId
            ? this.addresses.find((a) => a.addressId === this.product.addressId)
            : undefined;
        if (idMatch && idMatch.label !== text) {
            this.product.addressId = '';
            this.product.customerAddress = '';
        }
    }

    private getAddressInputText(): string {
        const a = this.product?.address;
        if (a == null) {
            return '';
        }
        if (typeof a === 'object' && a !== null && 'label' in a) {
            return String((a as { label?: string }).label || '').trim();
        }
        return String(a).trim();
    }

    /**
     * Decides list vs custom: exact match to a loaded master address → list; otherwise custom pipe address.
     * Returns false if address is empty.
     */
    private resolveAddressForProceed(): boolean {
        const text = this.getAddressInputText();
        if (!text) {
            this.messageService.add({
                severity: 'error',
                summary: 'Address required',
                detail: 'Please select an address from the list or enter a custom delivery address.',
                life: 4000
            });
            return false;
        }
        const byId = this.product.addressId
            ? this.addresses.find((a) => a.addressId === this.product.addressId)
            : undefined;
        const byLabel = this.addresses.find((a) => a.label === text);
        const listMatch =
            byId && byId.label === text ? byId : byLabel && byLabel.label === text ? byLabel : undefined;
        if (listMatch) {
            this.product.isCustom = 0;
            this.product.addressId = listMatch.addressId || '';
            this.product.customerAddress = listMatch.full?.combinedAddress || '';
            this.product.customAddress = '';
            this.product.address = listMatch.label;
            return true;
        }
        const customAddressValidation = this.validateCustomAddressLines(text);
        if (!customAddressValidation.valid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Invalid custom address',
                detail: customAddressValidation.message || 'Each address line must be 36 characters or less.',
                life: 4500
            });
            return false;
        }
        const normalized = this.normalizeCustomAddressPipe(text);
        this.product.isCustom = 1;
        this.product.customAddress = normalized;
        this.product.addressId = '';
        this.product.customerAddress = '';
        this.product.address = text;
        return true;
    }

    private validateCustomAddressLines(raw: string): { valid: boolean; message?: string } {
        const lines = (raw || '')
            .split(/\r?\n|\||,/)
            .map((line) => line.trim())
            .filter((line) => !!line);

        if (lines.length === 0) {
            return { valid: false, message: 'Please enter at least one address line.' };
        }

        const maxAddressLines = 4;
        if (lines.length > maxAddressLines) {
            return {
                valid: false,
                message: `Only ${maxAddressLines} address lines are allowed.`
            };
        }

        const maxCharsPerLine = 36;
        for (let i = 0; i < lines.length; i++) {
            if (lines[i].length > maxCharsPerLine) {
                return {
                    valid: false,
                    message: `Address line ${i + 1} exceeds ${maxCharsPerLine} characters.`
                };
            }
        }
        return { valid: true };
    }

    private normalizeCustomAddressPipe(raw: string): string {
        const lines = (raw || '')
            .split(/\r?\n|\||,/)
            .map((line) => line.trim())
            .filter((line) => !!line);
        return lines.join('|');
    }
    focusOrderTypeInput() {
        const input = this.orderTypeField?.el?.nativeElement?.querySelector('input');
        if (input) {
            input.focus();
        }
    }
    focusFacilityInput() {
        const input = this.facilityField?.el?.nativeElement?.querySelector('input');
        if (input) {
            input.focus();
        }
    }
    focusWarehouseInput() {
        const input = this.warehouseField?.el?.nativeElement?.querySelector('input');
        if (input) {
            input.focus();
        }
    }

    findIndexById(id: string): number {
        let index = -1;
        for (let i = 0; i < this.products().length; i++) {
            if (this.products()[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    createId(): string {
        let id = '';
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < 5; i++) {
            id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
    }

    private doCopyOrder(
        orderNum: string,
        copyMode: string = 'ALL',
        target?: { targetCustomerId: string; targetCustomerSnapshot: TargetCustomerSnapshot } | null
    ): void {
        localStorage.removeItem('orders');
        localStorage.removeItem('orderLines');
        localStorage.removeItem('routeParams');
        this.orderDraftService.clearDraft();
        const newId = this.createId();
        // Keep copy-order flow aligned with new-order flow for draft resume.
        localStorage.setItem('routeParams', JSON.stringify(newId));
        const state: Record<string, unknown> = { copyFromOrderNumber: orderNum, copyMode };
        if (target?.targetCustomerId && target?.targetCustomerSnapshot) {
            state['targetCustomerId'] = target.targetCustomerId;
            state['targetCustomerSnapshot'] = target.targetCustomerSnapshot;
        }
        this.navigateToSelectedItemDetails(newId, { state });
    }

    copyOrderFromInput(): void {
        this.openCopyOptionsDialog();
    }

    onCopyOrderInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const normalized = (input.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
        this.copyFromOrderNumber = normalized;
        input.value = normalized;
    }

    onCopyOrderPaste(event: ClipboardEvent): void {
        event.preventDefault();
        const pastedText = event.clipboardData?.getData('text/plain') || '';
        const pastedHtml = event.clipboardData?.getData('text/html') || '';
        const combined = `${pastedText}\n${pastedHtml}`;
        this.copyFromOrderNumber = this.extractOrderNumberFromDroppedText(combined);
        this.focusCopyOrderInput();
    }

    onCopyOrderDragOver(event: DragEvent): void {
        event.preventDefault();
    }

    onCopyOrderDrop(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        const dt = event.dataTransfer;
        const rawPlain = dt?.getData('text/plain') || '';
        const rawUri = dt?.getData('text/uri-list') || '';
        const rawHtml = dt?.getData('text/html') || '';
        const combined = `${rawPlain}\n${rawUri}\n${rawHtml}`;
        const extracted = this.extractOrderNumberFromDroppedText(combined);
        this.copyFromOrderNumber = extracted;
        this.focusCopyOrderInput();
    }

    onCopyOrderEnter(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.copyOrderFromInput();
    }

    private focusCopyOrderInput(): void {
        setTimeout(() => this.copyOrderInputRef?.nativeElement?.focus(), 0);
    }

    private extractOrderNumberFromDroppedText(value: string): string {
        const text = `${value || ''}`.toUpperCase();
        // Prefer well-known order prefixes from dragged links/text.
        const prefixed = text.match(/(?:^|[^A-Z0-9])((?:ORD|GER|FRA)[A-Z0-9]{7})(?=$|[^A-Z0-9])/);
        if (prefixed?.[0]) {
            return (prefixed[1] || prefixed[0]).slice(0, 10);
        }

        // Secondary: pick first alphanumeric token that looks like an order code.
        const tokens = text.match(/[A-Z0-9]{8,20}/g) || [];
        const candidate = tokens.find((t) => !t.startsWith('HTTP') && !t.startsWith('LOCALHOST') && /\d/.test(t));
        if (candidate) {
            return candidate.slice(0, 10);
        }

        // Final fallback: sanitized first 10 chars.
        const compact = text.replace(/[^A-Z0-9]/g, '');
        if (compact.startsWith('HTTP') || compact.startsWith('LOCALHOST')) {
            return '';
        }
        return compact.slice(0, 10);
    }

    isValidCopyOrderNumber(value: string): boolean {
        return /^[A-Z0-9]{10}$/.test((value || '').trim().toUpperCase());
    }

    get canShowCopyToDifferentCustomer(): boolean {
        return true;
    }

    private resetCopyDifferentCustomerState(): void {
        this.copyToDifferentCustomer = false;
        this.copyTargetCustomerName = null;
        this.copyTargetCustomerNumber = null;
        this.copyTargetCustomerOptions = [];
        this.copyTargetCustomerNumberOptions = [];
        this.copyTargetCustomerId = '';
        this.copyTargetCustomerSnapshot = null;
        this.copyTargetAddresses = [];
        this.copyTargetFilteredAddresses = [];
        this.copyTargetSelectedAddress = null;
        this.copyTargetAddressText = '';
        this.copyTargetDetailsLoading = false;
        this.copyTargetBlcd = null;
        this.copyTargetBlockWarningDialogVisible = false;
        this.copyTargetBlockWarningMessage = '';
        this.copyTargetBlockWarningAcknowledged = false;
        this.copyConfirmLoading = false;
    }

    onCopyToDifferentCustomerToggle(enabled: boolean): void {
        this.copyToDifferentCustomer = enabled;
        if (!enabled) {
            this.copyTargetCustomerName = null;
            this.copyTargetCustomerNumber = null;
            this.copyTargetCustomerId = '';
            this.copyTargetCustomerSnapshot = null;
            this.copyTargetAddresses = [];
            this.copyTargetFilteredAddresses = [];
            this.copyTargetSelectedAddress = null;
            this.copyTargetAddressText = '';
            this.copyTargetBlcd = null;
            this.copyTargetBlockWarningAcknowledged = false;
        }
    }

    filterCopyTargetCustomers(event: any): void {
        const query = event?.query || '';
        if (query.length < 3) {
            this.copyTargetCustomerOptions = [];
            return;
        }
        const search$ = this.searchLocalException
            ? this.productService.searchCustomersLocalException(query)
            : this.productService.searchCustomers(query);
        search$.pipe(takeUntil(this.destroy$)).subscribe({
            next: (res: any) => {
                this.copyTargetCustomerOptions = Array.isArray(res) ? res : res ? [res] : [];
            },
            error: () => {
                this.copyTargetCustomerOptions = [];
            }
        });
    }

    filterCopyTargetCustomerNumbers(event: any): void {
        const query = event?.query || '';
        if (query.length < 3) {
            this.copyTargetCustomerNumberOptions = [];
            return;
        }
        const search$ = this.searchLocalException
            ? this.productService.searchCustomersNumberLocalException(query)
            : this.productService.searchCustomerNumbers(query);
        search$.pipe(takeUntil(this.destroy$)).subscribe({
            next: (res: any) => {
                this.copyTargetCustomerNumberOptions = Array.isArray(res) ? res : res ? [res] : [];
            },
            error: () => {
                this.copyTargetCustomerNumberOptions = [];
            }
        });
    }

    onCopyTargetCustomerSelect(event: any): void {
        const customerObj = event?.value ?? event;
        if (!customerObj) {
            return;
        }
        this.copyTargetCustomerNumber = customerObj.CUNO || customerObj.CUSTOMER || '';
        this.copyTargetCustomerName = customerObj.CUNM || customerObj.CUSTOMER || '';
        const customerId = resolveNumericCustomerId(customerObj?.CUNO || customerObj?.customerId || customerObj?.id);
        if (!customerId) {
            this.messageService.add({
                severity: 'error',
                summary: 'Invalid customer',
                detail: 'Selected customer does not have a valid customer number.',
                life: 3500
            });
            return;
        }
        this.loadCopyTargetCustomerDetails(customerId);
    }

    onCopyTargetCustomerNumberSelect(event: any): void {
        this.onCopyTargetCustomerSelect(event);
    }

    private loadCopyTargetCustomerDetails(customerId: string): void {
        const facilityId = this.inMemoryStorage.get('facilityId') || '';
        this.copyTargetDetailsLoading = true;
        this.copyTargetBlockWarningAcknowledged = false;
        this.productService.getCustomerDetails(customerId, facilityId).subscribe({
            next: (details) => {
                this.copyTargetDetailsLoading = false;
                this.copyTargetCustomerId = customerId;
                this.copyTargetBlcd = details?.blcd != null ? String(details.blcd).trim() : null;

                let addresses: { label: string; addressId: any; full: any }[] = [];
                if (Array.isArray(details?.addresses) && details.addresses.length > 0) {
                    addresses = details.addresses.map((addr: any) => ({
                        label: [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4]
                            .filter(Boolean)
                            .join(', '),
                        addressId: addr.addressId,
                        full: addr
                    }));
                }

                this.copyTargetAddresses = addresses;
                this.copyTargetFilteredAddresses = [...addresses];
                const first = addresses[0];
                this.copyTargetSelectedAddress = first || null;
                this.copyTargetAddressText = first?.label || '';

                this.copyTargetCustomerSnapshot = {
                    name: this.copyTargetCustomerName?.CUNM || this.copyTargetCustomerName || details?.CUNM || '',
                    addressId: first?.addressId || '',
                    address: first?.label || '',
                    addressCountryCode: first?.full?.countryCode || details?.cscd || '',
                    isCustom: 0,
                    customAddress: '',
                    phoneNumber: details?.addresses?.[0]?.phoneNumber || '',
                    mail: details?.mail || '',
                    customerAddress: details?.addresses?.[0]?.combinedAddress || '',
                    vatRegistrationNo: details?.vrno || '',
                    txap: details?.txap,
                    pltb: details?.pltb || '',
                    defaultPriceList: details?.defaultPriceList || '',
                    cucd: details?.cucd || '',
                    cfc4: details?.cfc4 || '',
                    outstanding: details?.outstanding || 0,
                    totalOverdue: details?.totalOverdue || 0,
                    okcrl3: details?.okcrl3,
                    odud: details?.odud,
                    nood: details?.nood,
                    F1N096: details?.F1N096,
                    blcd: this.copyTargetBlcd,
                    creditLimit3: resolveCreditLimit3(details)
                };
                if (typeof this.copyTargetCustomerName === 'string' && this.copyTargetCustomerName) {
                    this.copyTargetCustomerSnapshot.name = this.copyTargetCustomerName;
                } else if (this.copyTargetCustomerName?.CUNM) {
                    this.copyTargetCustomerSnapshot.name = this.copyTargetCustomerName.CUNM;
                }
            },
            error: () => {
                this.copyTargetDetailsLoading = false;
                this.copyTargetCustomerId = '';
                this.copyTargetCustomerSnapshot = null;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Customer details failed',
                    detail: `Could not load details for customer ${customerId}.`,
                    life: 4000
                });
            }
        });
    }

    filterCopyTargetAddresses(event: any): void {
        const query = String(event?.query ?? '')
            .trim()
            .toLowerCase();
        if (!query) {
            this.copyTargetFilteredAddresses = [...this.copyTargetAddresses];
            return;
        }
        this.copyTargetFilteredAddresses = this.copyTargetAddresses.filter((a) =>
            String(a.label || '')
                .toLowerCase()
                .includes(query)
        );
    }

    onCopyTargetAddressSelect(event: any): void {
        const addr = event?.value ?? event;
        if (!addr) {
            return;
        }
        this.copyTargetSelectedAddress = addr;
        this.copyTargetAddressText = addr.label || '';
        if (this.copyTargetCustomerSnapshot) {
            this.copyTargetCustomerSnapshot = {
                ...this.copyTargetCustomerSnapshot,
                addressId: addr.addressId || '',
                address: addr.label || '',
                addressCountryCode: addr.full?.countryCode || this.copyTargetCustomerSnapshot.addressCountryCode,
                isCustom: 0,
                customAddress: '',
                customerAddress: addr.full?.combinedAddress || '',
                phoneNumber: addr.full?.phoneNumber || this.copyTargetCustomerSnapshot.phoneNumber
            };
        }
    }

    private resolveCopyTargetAddressForProceed(): boolean {
        const text = String(this.copyTargetAddressText || '').trim();
        if (!text) {
            this.messageService.add({
                severity: 'error',
                summary: 'Address required',
                detail: 'Select an address for the target customer or enter a custom delivery address.',
                life: 4000
            });
            return false;
        }
        const byId = this.copyTargetCustomerSnapshot?.addressId
            ? this.copyTargetAddresses.find((a) => a.addressId === this.copyTargetCustomerSnapshot?.addressId)
            : undefined;
        const byLabel = this.copyTargetAddresses.find((a) => a.label === text);
        const listMatch = byId && byId.label === text ? byId : byLabel && byLabel.label === text ? byLabel : undefined;
        if (listMatch) {
            this.onCopyTargetAddressSelect(listMatch);
            return true;
        }
        const customValidation = this.validateCustomAddressLines(text);
        if (!customValidation.valid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Invalid custom address',
                detail: customValidation.message || 'Each address line must be 36 characters or less.',
                life: 4500
            });
            return false;
        }
        const normalized = this.normalizeCustomAddressPipe(text);
        if (this.copyTargetCustomerSnapshot) {
            this.copyTargetCustomerSnapshot = {
                ...this.copyTargetCustomerSnapshot,
                isCustom: 1,
                customAddress: normalized,
                addressId: '',
                customerAddress: '',
                address: text
            };
        }
        return true;
    }

    openCopyOptionsDialog(): void {
        const orderNum = (this.copyFromOrderNumber || '').trim();
        if (!orderNum) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Order number required',
                detail: 'Please enter an order number to copy.',
                life: 3000
            });
            return;
        }
        if (!this.isValidCopyOrderNumber(orderNum)) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Invalid order number',
                detail: 'Copy order number must be exactly 10 characters (letters/numbers).',
                life: 3000
            });
            return;
        }
        this.copyModeSelection = 'ALL';
        this.resetCopyDifferentCustomerState();
        this.copyOptionsDialogVisible = true;
    }

    confirmCopyOrder(): void {
        const orderNum = (this.copyFromOrderNumber || '').trim();
        if (!orderNum) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Order number required',
                detail: 'Please enter an order number to copy.',
                life: 3000
            });
            return;
        }
        if (!this.isValidCopyOrderNumber(orderNum)) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Invalid order number',
                detail: 'Copy order number must be exactly 10 characters (letters/numbers).',
                life: 3000
            });
            return;
        }

        const useDifferentCustomer =
            this.canShowCopyToDifferentCustomer && this.copyToDifferentCustomer && !!this.copyTargetCustomerId;

        if (this.copyToDifferentCustomer && !this.canShowCopyToDifferentCustomer) {
            this.messageService.add({
                severity: 'warn',
                summary: 'V2 required',
                detail: 'Copy to a different customer is only available when Item Details V2 is selected.',
                life: 4000
            });
            return;
        }

        if (this.copyToDifferentCustomer && this.canShowCopyToDifferentCustomer) {
            if (!resolveNumericCustomerId(this.copyTargetCustomerId) || !this.copyTargetCustomerSnapshot) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Target customer required',
                    detail: 'Select a target customer and wait for details to load.',
                    life: 4000
                });
                return;
            }
            if (!this.resolveCopyTargetAddressForProceed()) {
                return;
            }
            if (String(this.copyTargetBlcd ?? '').trim() === '2' && !this.copyTargetBlockWarningAcknowledged) {
                this.copyTargetBlockWarningMessage = `Customer ${this.copyTargetCustomerId} is blocked in M3 (block code 2). You can still create the order; sync to M3 will be blocked until the block is cleared.`;
                this.copyTargetBlockWarningDialogVisible = true;
                return;
            }
            this.proceedConfirmCopyOrderWithSourceCheck(orderNum, useDifferentCustomer);
            return;
        }

        this.copyOptionsDialogVisible = false;
        this.doCopyOrder(orderNum, this.copyModeSelection || 'ALL');
    }

    onCopyTargetBlockWarningCancel(): void {
        this.copyTargetBlockWarningDialogVisible = false;
    }

    onCopyTargetBlockWarningProceed(): void {
        this.copyTargetBlockWarningDialogVisible = false;
        this.copyTargetBlockWarningAcknowledged = true;
        const orderNum = (this.copyFromOrderNumber || '').trim();
        this.proceedConfirmCopyOrderWithSourceCheck(orderNum, true);
    }

    private proceedConfirmCopyOrderWithSourceCheck(orderNum: string, useDifferentCustomer: boolean): void {
        if (!useDifferentCustomer) {
            this.copyOptionsDialogVisible = false;
            this.doCopyOrder(orderNum, this.copyModeSelection || 'ALL');
            return;
        }

        const company = this.userService.getCompanyId();
        const division = this.division || this.userService.getDivisionId() || '';
        this.copyConfirmLoading = true;
        this.loaderService.show('Validating source order…', 'Please wait');
        this.itemDetailsService.getOrderHeader(orderNum, company, division, 'CustomerOrder').subscribe({
            next: (header: any) => {
                this.copyConfirmLoading = false;
                this.loaderService.hide();
                const sourceCustomerId = resolveNumericCustomerId(
                    header?.customerId || header?.CUNO || header?.customer
                );
                const targetId = resolveNumericCustomerId(this.copyTargetCustomerId);
                if (sourceCustomerId && targetId && sourceCustomerId === targetId) {
                    this.copyOptionsDialogVisible = false;
                    this.doCopyOrder(orderNum, this.copyModeSelection || 'ALL');
                    return;
                }
                const sourceCucd = header?.cucd || header?.CUCD || header?.currency || '';
                const targetCucd = this.copyTargetCustomerSnapshot?.cucd || '';
                if (isCopyCurrencyMismatch(sourceCucd, targetCucd)) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Currency mismatch',
                        detail: `Source currency (${sourceCucd}) differs from target (${targetCucd}). Rates are kept from the source order, so cross-currency copy is blocked.`,
                        life: 6000
                    });
                    return;
                }
                const snapshot = this.copyTargetCustomerSnapshot;
                if (!snapshot || !targetId) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Target customer required',
                        detail: 'Select a target customer before copying.',
                        life: 4000
                    });
                    return;
                }
                this.copyOptionsDialogVisible = false;
                this.doCopyOrder(orderNum, this.copyModeSelection || 'ALL', {
                    targetCustomerId: targetId,
                    targetCustomerSnapshot: { ...snapshot }
                });
            },
            error: () => {
                this.copyConfirmLoading = false;
                this.loaderService.hide();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Order not found',
                    detail: 'Could not load the source order to validate currency and customer.',
                    life: 4000
                });
            }
        });
    }

    saveProduct() {
        // Ensure product is initialized
        if (!this.product) {
            this.product = {} as Product;
        }
        this.submitted = true;

        // Validation: require all fields
        if (!this.product.customer || !this.product.facilityId || !this.product.warehouseId || !this.product.orderTypeId || !this.product.requestedDate) {
            this.messageService.add({
                severity: 'error',
                summary: 'Missing Required Fields',
                detail: 'Please fill all required fields before proceeding.',
                life: 4000
            });
            return;
        }

        // Ensure the name is assigned before validation
        if (!this.product.name) {
            this.product.name = this.selectedCustomer?.CUNM || 'No Name Available';
        }

        if (!this.resolveAddressForProceed()) {
            return;
        }

        if (String(this.selectedCustomerBlcd ?? '').trim() === '2' && !this.customerBlockWarningAcknowledged) {
            this.customerBlockWarningMessage =
                `Customer ${this.product.customer} is blocked in M3 (block code 2). You can still create the order; sync to M3 will be blocked until the block is cleared.`;
            this.customerBlockWarningDialogVisible = true;
            return;
        }

        this.continueSaveProductAfterBlockWarning();
    }

    customerBlockWarningDialogVisible = false;
    customerBlockWarningMessage = '';
    selectedCustomerBlcd: string | null = null;
    private customerBlockWarningAcknowledged = false;

    onCustomerBlockWarningCancel(): void {
        this.customerBlockWarningDialogVisible = false;
    }

    onCustomerBlockWarningProceed(): void {
        this.customerBlockWarningDialogVisible = false;
        this.customerBlockWarningAcknowledged = true;
        this.continueSaveProductAfterBlockWarning();
    }

    private continueSaveProductAfterBlockWarning(): void {
        const addressLabel = typeof this.product.address === 'string' ? this.product.address : '';
        const addressId = this.product.addressId || '';
        const normalizedCustomAddress = this.normalizeCustomAddressPipe(
            this.product.isCustom === 1 ? this.product.customAddress || '' : ''
        );

        // Debug: print all relevant fields before validation
        console.log('saveProduct fields:', {
            customer: this.product.customer,
            address: addressLabel,
            addressId: addressId,
            isCustom: this.product.isCustom,
            facilityId: this.product.facilityId,
            warehouseId: this.product.warehouseId,
            orderTypeId: this.product.orderTypeId,
            requestedDate: this.product.requestedDate,
            quantity: this.product.quantity,
            name: this.product.name
        });

        let _products = this.products();

        if (this.product.id) {
            // Update existing product
            const index = this.findIndexById(this.product.id);
            if (index !== -1) {
                _products[index] = this.product;
                this.products.set([..._products]);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Product Updated',
                    life: 3000
                });
            }
        } else {
            // Create new product
            this.product.id = this.createId();
            this.products.set([..._products, this.product]);
            this.messageService.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Product Created',
                life: 3000
            });
        }

        // Map dialog fields to orderHeader with correct property names
        const orderHeader = {
            name: this.product.name,
            customer: this.product.customer || '',
            address: this.product.isCustom === 1 ? normalizedCustomAddress || addressLabel : addressLabel,
            addressId: addressId,
            facilityId: this.product.facilityId || '',
            warehouseId: this.product.warehouseId || '',
            orderTypeId: this.product.orderTypeId || '',
            requestedDate: this.product.requestedDate || '',
            quantity: this.product.quantity || 0,
            isCustom: this.product.isCustom === 1 ? 1 : 0,
            customAddress: this.product.isCustom === 1 ? normalizedCustomAddress : ''
        };
        console.log('Order Header to save:', orderHeader);

        // Save to localStorage so display component sees the new data
        // localStorage.setItem('products', JSON.stringify(this.products()));

        localStorage.setItem('routeParams', JSON.stringify(this.product.id));
        // Close dialog before navigating
        this.productDialog = false;
        this.customerBlockWarningAcknowledged = false;
        // Navigate to item details for the new/updated product, passing orderHeader
        this.navigateToSelectedItemDetails(String(this.product.id), { state: { product: this.product, orderHeader } });
    }
    filterCustomers(event: any) {
        const query = event.query;
    
        if (query.length >= 3) {
            const useLocalException = this.searchLocalException;
            const search$ = useLocalException
                ? this.productService.searchCustomersLocalException(query)
                : this.productService.searchCustomers(query);
            search$
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (res: any) => {
                        console.log('Customer search response:', res);
                        if (Array.isArray(res)) {
                            this.customerOptions = res;
                        } else if (res) {
                            this.customerOptions = [res];
                        } else {
                            this.customerOptions = [];
                        }
                        console.log('Customer options set:', this.customerOptions);
                    },
                    error: (err) => {
                        console.error('Error searching customers:', err);
                        this.customerOptions = [];
                    }
                });
        } else {
            this.customerOptions = [];
        }
    }
    filterCustomerNumbers(event: any) {
        const query = event.query;
    
        if (query.length >= 3) {
            const useLocalException = this.searchLocalException;
            const search$ = useLocalException
                ? this.productService.searchCustomersNumberLocalException(query)
                : this.productService.searchCustomerNumbers(query);
            search$
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (res: any) => {
                        console.log('Customer number search response:', res);
                        if (Array.isArray(res)) {
                            this.customerNumberOptions = res;
                        } else if (res) {
                            this.customerNumberOptions = [res];
                        } else {
                            this.customerNumberOptions = [];
                        }
                        console.log('Customer number options set:', this.customerNumberOptions);
                    },
                    error: (err) => {
                        console.error('Error searching customer numbers:', err);
                        this.customerNumberOptions = [];
                    }
                });
        } else {
            this.customerNumberOptions = [];
        }
    }

    onCustomerSelect(event: any) {
        console.log('Customer selected:', event);

        this.loaderService.show('Loading customer details...', 'Please wait...');
        // Ensure product is initialized
        if (!this.product) {
            this.product = {} as Product;
        }
        const customerObj = event.value;
        if (!customerObj) {
            this.clearCustomerFields();
            return;
        }
            // ⭐ Populate both customer number and name fields
    this.selectedCustomerNumber = customerObj.CUNO || customerObj.CUSTOMER || '';
    this.selectedCustomer = customerObj.CUNM || customerObj.CUSTOMER || '';

        this.product.name = customerObj.CUNM || 'No Name Available';
        const customerId = customerObj?.CUNO || customerObj?.customerId || customerObj?.id || customerObj;
        console.log('Extracted customerId for details API:', customerId);

        if (customerId && typeof customerId === 'string') {
            this.product.customer = customerId;
            // Reset product fields
            this.product.requestedDate = this.todayStr;
            this.product.address = '';
            this.product.addressId = '';
            this.product.customAddress = '';
            this.product.isCustom = 0;
            this.product.facilityId = '';
            this.product.warehouseId = '';
            this.product.orderTypeId = '';
            this.product.quantity = 0;
            this.product.id = this.product.id || '';
            this.product.description = undefined;
            this.product.category = undefined;
            this.product.price = undefined;
            this.product.inventoryStatus = undefined;

            this.productDialog = true;
            this.selectedCustomerDetails = null;
            this.addresses = [];
            this.filteredAddresses = [];
            this.categories = [];
            this.filteredCategories = [];
            this.warehouses = [];
            this.filteredWarehouses = [];
            this.filteredStatuses = [];
            const facilityId = this.inMemoryStorage.get('facilityId');
            const warehouseId = this.inMemoryStorage.get('warehouseId');

            this.productService.getCustomerDetails(customerId, facilityId).subscribe({
                next: (details) => {
                    console.log('Customer details API response:', details);
                    this.loaderService.hide();
                    this.selectedCustomerBlcd = details?.blcd != null ? String(details.blcd).trim() : null;
                    this.customerBlockWarningAcknowledged = false;
                    let addresses: { label: string; addressId: any; full: any }[] = [];

                    if (Array.isArray(details.addresses) && details.addresses.length > 0) {
                        console.log('Processing multiple addresses:1', details.addresses);

                        addresses = details.addresses.map((addr: any) => ({
                            label: [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4].filter(Boolean),
                            addressId: addr.addressId,
                            full: addr
                        }));
                        console.log('Processed addresses:', addresses);
                    } else if (Array.isArray(details) && details.length > 0) {
                        console.log('Processing multiple addresses from array22:', details);

                        addresses = details.map((addr: any) => ({
                            label: [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4].filter(Boolean).join(', '),
                            addressId: addr.addressId,
                            full: addr
                        }));
                        console.log('Processed addresses:', addresses);
                    } else if (details.addressLine1) {
                        console.log('Processing single address3:', details);

                        addresses = [
                            {
                                label: [details.addressLine1, details.addressLine2, details.addressLine3, details.addressLine4].filter(Boolean).join(', '),
                                addressId: details.addressId,
                                full: details
                            }
                        ];
                        console.log('Processed addresses:', addresses);
                    }

                    // Assign to component properties

                    // Set default address and addressId if available
                    if (addresses.length > 0) {
                        const mappedAddresses = addresses.map((a) => ({
                            ...a,
                            label: Array.isArray(a.label) ? a.label.filter(Boolean).join(', ') : a.label
                        }));
                        this.addresses = mappedAddresses;
                        this.filteredAddresses = [...mappedAddresses];
                        this.product.address = mappedAddresses[0].label;
                        this.product.addressId = mappedAddresses[0].addressId;
                        this.product.addressCountryCode = mappedAddresses[0].full?.countryCode || '';
                        console.log('Filtered Addresses:', this.filteredAddresses);
                        console.log('Product Address:', this.product.address);
                        console.log('Product AddressId:', this.product.addressId);
                        console.log('Addresses:', this.addresses);
                    } else {
                        this.product.address = '';
                        this.product.addressId = '';
                    }

                    // Set other product fields from details
                    if (details.addresses && details.addresses.length > 0) {
                        this.product.phoneNumber = details.addresses[0].phoneNumber || '';
                        this.product.customerAddress = details.addresses[0].combinedAddress;
                        this.product.mail = details.mail || '';
                    } else if (details.phoneNumber || details.combinedAddress) {
                        this.product.phoneNumber = details.phoneNumber || '';
                        this.product.customerAddress = details.combinedAddress || '';
                        this.product.mail = details.mail || '';
                    } else {
                        this.product.phoneNumber = '';
                        this.product.customerAddress = '';
                        this.product.mail = '';
                    }

                    this.product.phoneNumber = details.addresses?.[0]?.phoneNumber || '';
                    this.product.countryCode = details.addresses?.[0]?.countryCode || '';
                    this.product.customerAddress = details.addresses?.[0]?.combinedAddress || '';
                    this.product.vatRegistrationNo = details.vrno || '';
                    this.product.outstanding = details.outstanding || 0;
                    this.product.totalOverdue = details.totalOverdue || 0;
                    this.product.okcrl3 = details.okcrl3;
                    this.product.odud = details.odud;
                    this.product.nood = details.nood;
                    this.product.creditLimit3 = resolveCreditLimit3(details);
                    console.log('[HighOverdue] Orders1 customer details loaded', {
                        customerId,
                        outstanding: this.product.outstanding,
                        totalOverdue: this.product.totalOverdue,
                        creditLimit3: this.product.creditLimit3,
                        okcrl3: details.okcrl3,
                        creditLimit3Source: details.okcrl3 ? 'okcrl3' : details.creditLimit3 != null ? 'creditLimit3' : 'mock'
                    });
                    this.product.defaultPriceList = details.defaultPriceList || '';
                    this.product.pltb = details.pltb || '';
                    this.product.cucd = details.cucd || '';
                    this.product.cfc4 = details.cfc4 || '';
                    this.product.txap = details.txap || '';
                    const minimumOrderMargin = Number(details.F1N096) || 0;
                    if (minimumOrderMargin > 0) {
                        this.product.minimumOrderMargin = minimumOrderMargin;
                        this.product.F1N096 = details.F1N096;
                    }

                    // Facility, warehouse, order type
                    console.log('Setting facilityId, warehouseId, orderTypeId:', details.ortp);
                    console.log('Setting facilityId, warehouseId, orderTypeId:', details.ORDERTYPE);
                    console.log('Setting facilityId, warehouseId, orderTypeId:', details.orderType);

                    this.product.orderTypeId = this.resolveCustomerSearchOrderTypeId(details);

                    this.product.requestedDate = this.todayStr;
                    this.product.facilityId = facilityId;
                    this.fetchFacilities();
                    this.fetchWarehouses();
                    this.fetchOrderTypes();
                    setTimeout(() => {
                        // this.calculateVatPercentage();
                    }, 300);
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Customer details loaded',
                        detail: `Details loaded for customer ${customerId}`,
                        life: 2000
                    });
                },
                error: (err) => {
                    this.loaderService.hide();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: `Failed to load customer details for id: ${customerId}`,
                        life: 3000
                    });
                    console.error('Customer details API error:', err);
                }
            });
        } else {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No valid customerId found in selected customer.',
                life: 4000
            });
            console.error('No valid customerId found in selected customer:', customerObj);
        }
        this.selectedCustomer = customerObj;
    }
    // Add this method after onCustomerSelect (around line 1710)
onCustomerNumberSelect(event: any) {
    console.log('Customer Number selected:', event);
    
    const customerObj = event.value;
    if (!customerObj) {
        this.clearCustomerFields();
        return;
    }
    
    // ⭐ Populate both fields
    this.selectedCustomerNumber = customerObj.CUNO || customerObj.CUSTOMER || '';
    this.selectedCustomer = customerObj.CUNM || customerObj.CUSTOMER || '';
    
    // Call the same handler to load customer details
    this.onCustomerSelect(event);
}
// Add these methods after onCustomerNumberSelect
onCustomerNumberInput(event: any) {
    const value = event.target?.value || '';
    console.log('Customer Number input changed:', value);
    
    // If field is cleared, clear the other field too
    if (!value || value.trim() === '') {
        this.selectedCustomer = '';
        this.clearCustomerFields();
    }
}

onCustomerNameInput(event: any) {
    const value = event.target?.value || '';
    console.log('Customer Name input changed:', value);
    
    // If field is cleared, clear the other field too
    if (!value || value.trim() === '') {
        this.selectedCustomerNumber = '';
        this.clearCustomerFields();
    }
}
    onFacilityChange(newFacilityId: string) {
        // Only trigger if a customer is already selected
        if (this.selectedCustomer && newFacilityId) {
            this.loaderService.show('Loading customer details...', 'Please wait...');
            // Call onCustomerSelect with the updated facility
            const customerId = this.selectedCustomer?.CUNO || this.selectedCustomer?.customerId || this.selectedCustomer?.id || this.selectedCustomer;
            console.log('Updating customer details for facility change:', customerId, newFacilityId);
            this.productService.getCustomerDetails(customerId, newFacilityId).subscribe({
                next: (details) => {
                    this.loaderService.hide();
                    console.log('Customer details API response:', details);
                    this.selectedCustomerBlcd = details?.blcd != null ? String(details.blcd).trim() : null;
                    this.customerBlockWarningAcknowledged = false;

                    let addresses: { label: string; addressId: any; full: any }[] = [];

                    if (Array.isArray(details.addresses) && details.addresses.length > 0) {
                        console.log('Processing multiple addresses:1', details.addresses);

                        addresses = details.addresses.map((addr: any) => ({
                            label: [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4].filter(Boolean),
                            addressId: addr.addressId,
                            full: addr
                        }));
                        console.log('Processed addresses:', addresses);
                    } else if (Array.isArray(details) && details.length > 0) {
                        console.log('Processing multiple addresses from array22:', details);

                        addresses = details.map((addr: any) => ({
                            label: [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4].filter(Boolean).join(', '),
                            addressId: addr.addressId,
                            full: addr
                        }));
                        console.log('Processed addresses:', addresses);
                    } else if (details.addressLine1) {
                        console.log('Processing single address3:', details);

                        addresses = [
                            {
                                label: [details.addressLine1, details.addressLine2, details.addressLine3, details.addressLine4].filter(Boolean).join(', '),
                                addressId: details.addressId,
                                full: details
                            }
                        ];
                        console.log('Processed addresses:', addresses);
                    }

                    // Assign to component properties

                    // Set default address and addressId if available
                    if (addresses.length > 0) {
                        const mappedAddresses = addresses.map((a) => ({
                            ...a,
                            label: Array.isArray(a.label) ? a.label.filter(Boolean).join(', ') : a.label
                        }));
                        this.addresses = mappedAddresses;
                        this.filteredAddresses = [...mappedAddresses];
                        this.product.address = mappedAddresses[0].label;
                        this.product.addressId = mappedAddresses[0].addressId;
                        this.product.addressCountryCode = mappedAddresses[0].full?.countryCode || '';
                        console.log('Filtered Addresses:', this.filteredAddresses);
                        console.log('Product Address:', this.product.address);
                        console.log('Product AddressId:', this.product.addressId);
                        console.log('Addresses:', this.addresses);
                    } else {
                        this.product.address = '';
                        this.product.addressId = '';
                    }

                    // Set other product fields from details
                    if (details.addresses && details.addresses.length > 0) {
                        this.product.phoneNumber = details.addresses[0].phoneNumber || '';
                        this.product.customerAddress = details.addresses[0].combinedAddress;
                    } else if (details.phoneNumber || details.combinedAddress) {
                        this.product.phoneNumber = details.phoneNumber || '';
                        this.product.customerAddress = details.combinedAddress || '';
                    } else {
                        this.product.phoneNumber = '';
                        this.product.customerAddress = '';
                    }
                    this.product.phoneNumber = details.addresses?.[0]?.phoneNumber || '';
                    this.product.countryCode = details.addresses?.[0]?.countryCode || '';
                    this.product.customerAddress = details.addresses?.[0]?.combinedAddress || '';
                    this.product.vatRegistrationNo = details.vrno || '';
                    this.product.outstanding = details.outstanding || 0;
                    this.product.totalOverdue = details.totalOverdue || 0;
                    this.product.okcrl3 = details.okcrl3;
                    this.product.odud = details.odud;
                    this.product.nood = details.nood;
                    this.product.creditLimit3 = resolveCreditLimit3(details);
                    console.log('[HighOverdue] Orders1 customer details loaded', {
                        customerId,
                        outstanding: this.product.outstanding,
                        totalOverdue: this.product.totalOverdue,
                        creditLimit3: this.product.creditLimit3,
                        okcrl3: details.okcrl3,
                        creditLimit3Source: details.okcrl3 ? 'okcrl3' : details.creditLimit3 != null ? 'creditLimit3' : 'mock'
                    });
                    this.product.defaultPriceList = details.defaultPriceList || '';
                    this.product.pltb = details.pltb || '';
                    this.product.cucd = details.cucd || '';
                    this.product.cfc4 = details.cfc4 || '';
                    this.product.txap = details.txap || '';
                    const facilityMinimumOrderMargin = Number(details.F1N096) || 0;
                    if (facilityMinimumOrderMargin > 0) {
                        this.product.minimumOrderMargin = facilityMinimumOrderMargin;
                        this.product.F1N096 = details.F1N096;
                    }
                    const warehouseId = this.inMemoryStorage.get('warehouseId');
                    // Facility, warehouse, order type
                    this.product.facilityId = newFacilityId;
                    this.product.warehouseId = warehouseId;
                    this.product.orderTypeId = this.resolveCustomerSearchOrderTypeId(details);
                    this.product.requestedDate = this.todayStr;

                    // this.fetchFacilities();
                    // this.fetchWarehouses();
                    // this.fetchOrderTypes();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Customer details loaded',
                        detail: `Details loaded for customer ${customerId}`,
                        life: 2000
                    });
                },
                error: (err) => {
                    this.loaderService.hide();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: `Failed to load customer details for id: ${customerId}`,
                        life: 4000
                    });
                    console.error('Customer details API error:', err);
                }
            });
        }
    }

    // Add this method to clear all fields when customer is removed
    clearCustomerFields() {

        this.selectedCustomer = null;
        this.selectedCustomerNumber = null;
        this.customerNumberOptions = [];
        this.customerOptions = [];
        this.selectedCustomerBlcd = null;
        this.customerBlockWarningAcknowledged = false;
        this.customerBlockWarningDialogVisible = false;
        this.product = {
            customerNumber: '',
            customer: '',
            address: '',
            facility: '',
            warehouse: '',
            orderType: '',
            requestedDate: '',
            quantity: 0,
            Name: '',
            isCustom: 0,
            customAddress: ''
        } as any;
        this.selectedCustomerDetails = null;
        this.addresses = [];
        this.filteredAddresses = [];
        this.categories = [];
        this.filteredCategories = [];
        this.warehouses = [];
        this.filteredWarehouses = [];
        this.filteredStatuses = [];
        this.orderType = [];
    }

    filterAddresses(event: any) {
        console.log('Filtering addresses with query:', event);

        const query = event.query ? event.query.toLowerCase() : '';
        if (!query) {
            this.filteredAddresses = [...this.addresses];
            return;
        }
        this.filteredAddresses = this.addresses.filter((a) => a.label.toLowerCase().includes(query));
        console.log('Filtered Addresses:', this.addresses);
        console.log(this.product.address);
    }
    onAddressChanged(event: any) {
        this.loaderService.show('Loading address details...', 'Please wait...');
        console.log('Address changed by user:', event);
        console.log('Current product address before change:', this.product.addressId);

        console.log(this.product.address);

        if (typeof this.product.address === 'object') {
            const addressLabel = this.product.address as { label?: string; addressId?: string; full?: any };
            const combinedAddress = addressLabel.full.combinedAddress || '';
            const extractedLabel = addressLabel.label;
            const extractedAddressId = addressLabel.addressId;

            this.product.customerAddress = combinedAddress;
            this.product.address = extractedLabel || '';
            this.product.addressId = extractedAddressId || '';
            this.product.addressCountryCode = addressLabel.full?.countryCode || '';
            this.product.isCustom = 0;
            this.product.customAddress = '';
            console.log('Combined Address:', combinedAddress);
            console.log('Extracted Label:', extractedLabel);
            console.log('Extracted Address ID:', extractedAddressId);
            console.log('Product after address change:', this.product.addressCountryCode);
        } else {
            console.log('Address is a string:', this.product.address);
        }
        // console.log(addr?.addressId);

        setTimeout(() => {
            this.loaderService.hide();
        }, 200);
        this.calculateVatPercentage();

        // You can also log the selected addressId or label if needed:
        // console.log('Selected addressId:', event.addressId);s
        // console.log('Selected address label:', event.label);
    }
    filterCategories(event: any) {
        const query = event.query.toLowerCase();
        this.filteredCategories = this.categories.filter((f) => typeof f === 'string' && f.toLowerCase().includes(query));
    }

    // filterStatuses(event: any) {
    //     const query = event.query?.toLowerCase() || '';
    //     // const statuses = Array.isArray(this.statuses) ? this.statuses : [];
    //     this.filteredStatuses = this.orderType.filter((s) => typeof s === 'string' && s.toLowerCase().includes(query));
    // }

    private searchTerms = new Subject<string>();

    setupCustomerSearch() {
        this.searchTerms
            .pipe(
                //   debounceTime(300),
                distinctUntilChanged(),
                switchMap((term) => (term ? this.productService.searchCustomers(term) : []))
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((results) => {
                console.log('API Response:', results);
                this.customerOptions = results;
                
            });
    }

    onCustomerInput(event: any) {
        const query = event.query;
        if (query) {
            this.searchTerms.next(query);
        } else {
            this.customerSuggestions = [];
        }
    }

    // Optional: focus to next input
    goBack() {
        this.router.navigate(['/item-details']);
    }

    // Add this method to be called by the refresh button
    // ...existing code...
    // Add/replace this method
    refreshOrders() {
        // Reset paging to defaults so we don't keep the 10k page size from loaddata()
        this.currentPage = 0;
        this.pageSize = 100; // default page size you want after refresh
        this.totalElements = 0;
        this.totalPages = 0;
        this.lastScrollTop = 0;
        this.lastRefreshTime = new Date();
        // Clear any stored full data and table state
        this.originalData = [];
        this.isShowingGlobalSearchResults = false;
        this.isShowingDeliverySearchResults = false;
        this.deliverySearchTerm = '';
        this.products.set([]);
        try {
            // reset PrimeNG table filters/sort/virtual scroll position if available
            this.dt?.reset();
        } catch (e) {
            // ignore if dt not ready
            console.warn('Failed to reset table', e);
        }

        // load first page with default pageSize
        this.loadOrderHeaders(this.currentPage, this.pageSize);
    }
    // ...existing code...

    onSyncOrder(product: any) {
        console.log('Sync clicked', product);
        this.confirmationService.confirm({
            message: 'Are you sure you want to submit the order?',
            header: 'Confirm Submission',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.loaderService.show(`Syncing order... ${product.orderNumber}`, 'Please wait...');

                this.productService
                    .getOrderHeader(product.orderNumber, 'CustomerOrder')
                    .pipe(
                        takeUntil(this.destroy$),
                        finalize(() => this.loaderService.hide())
                    )
                    .subscribe({
                        next: (headerResp) => {
                            const header = Array.isArray(headerResp) ? headerResp[0] : headerResp;
                            if (!header) {
                                this.messageService.add({
                                    severity: 'error',
                                    summary: 'Order Header Error',
                                    detail: 'Order header not found. Cannot sync.',
                                    life: 4000
                                });
                                return;
                            }

                            const payload = {
                                status: header.status ?? product.status,
                                referenceOrderId: header.referenceOrderId ?? product.referenceOrderId,
                                company: this.inMemoryStorage.get('company') || '',
                                division: this.inMemoryStorage.get('division') || ''
                            };

                            console.log('Payload for FetchFirmOrderReleaseDetailsFromM3:', payload);
                            this.loaderService.show('Calling M3 release details API...', 'Please wait...');

                            this.productService
                                .fetchFirmOrderReleaseDetailsFromM3(payload)
                                .pipe(takeUntil(this.destroy$))
                                .subscribe({
                                    next: (res) => {
                                        this.loaderService.hide();
                                        this.messageService.add({
                                            severity: 'success',
                                            summary: 'Sync Completed',
                                            detail: 'Sync Completed'
                                        });
                                        console.log('FetchFirmOrderReleaseDetailsFromM3 response:', res);
                                        this.refreshOrders();
                                    },
                                    error: (err) => {
                                        this.loaderService.hide();
                                        this.messageService.add({
                                            severity: 'error',
                                            summary: 'Sync Failed',
                                            detail: 'Failed to Sync.',
                                            life: 4000
                                        });
                                        console.error('FetchFirmOrderReleaseDetailsFromM3 API error:', err);
                                    }
                                });
                        },
                        error: (err) => {
                            const detail = err?.error?.Message || err?.error?.message || 'Failed to fetch order header.';
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Order Header Error',
                                detail
                            });
                            console.error('GetOrderHeader API error:', err);
                        }
                    });
            }
        });
    }

    draftDialogVisible = false;

    showDraftDialogIfNeeded() {
        const draftOrder = localStorage.getItem('orders');
        const draftOrderLines = localStorage.getItem('orderLines');
        const routeParams = localStorage.getItem('routeParams');
        console.log('routeParams:', routeParams);
        console.log('draftOrder:', draftOrder);
        console.log('draftOrderLines:', draftOrderLines);

        if (draftOrder && draftOrderLines) {
            this.draftDialogVisible = true;
        }
    }

    discardDraft() {
        localStorage.removeItem('orders');
        localStorage.removeItem('orderLines');
        localStorage.removeItem('routeParams');
        this.orderDraftService.clearDraft();
        this.draftDialogVisible = false;
        this.loadOrderHeaders(); // Now load the manage orders data
    }
    onDraftDialogHide() {
        // this.loadOrderHeaders();

        // Only load orders if the user closed the dialog without continuing the draft
        if (localStorage.getItem('orders') || localStorage.getItem('orderLines')) {
            // User closed the dialog without discarding, so do NOT load orders
            // (You may want to show the dialog again or do nothing)
            // Optionally, you can clear the dialog state here if needed
        } else {
            // Draft was discarded, so load orders
            // this.loadOrderHeaders();
        }
    }

    //     draftOrder = JSON.parse(localStorage.getItem('orders') || '{}');
    // draftOrderLines = JSON.parse(localStorage.getItem('orderLines') || '[]');

    continueDraft() {
        const draftOrder = localStorage.getItem('orders');
        const draftOrderLines = localStorage.getItem('orderLines');
        const routeParams = JSON.parse(localStorage.getItem('routeParams') || '{}');
        console.log(draftOrder);
        console.log(draftOrderLines);
        console.log(routeParams);
        console.log('Continuing draft with:', {
            draftOrder,
            draftOrderLines,
            routeParams
        });

        // Set data in the shared service
        this.orderDraftService.orderHeader = draftOrder ? JSON.parse(draftOrder) : null;
        this.orderDraftService.orderLines = draftOrderLines ? JSON.parse(draftOrderLines) : [];
        console.log('Draft order and lines set in service:', {
            orderHeader: this.orderDraftService.orderHeader,
            orderLines: this.orderDraftService.orderLines
        });
        const rawOrderNumber = this.orderDraftService.orderHeader[0]?.orderNumber || '';
        const orderNumber = `${rawOrderNumber}`.trim();
        const hasRealOrderNumber = !!orderNumber && orderNumber !== 'New Order';
        console.log(this.orderDraftService.orderHeader);
        console.log(this.orderDraftService.orderLines);

        setTimeout(() => {
            const orderNumber1 = this.orderDraftService.orderHeader[0]?.orderNumber || '';

            console.log('Navigating to item with orderNumber:', orderNumber1);
        }, 1000);

        // Navigate
        if (routeParams && !hasRealOrderNumber) {
            console.log('Navigating to item with routeParams:', routeParams);
            this.navigateToSelectedItemDetails(String(routeParams));
        } else if (hasRealOrderNumber) {
            this.navigateToSelectedItemDetails(String(orderNumber));
            console.log('Navigating to item with orderNumber:', orderNumber);
        } else {
            this.router.navigate(['/Orders1']);
            console.log('Missing route params/order number. Staying on Orders page.');
        }
    }

    fetchFacilities() {
        const facilityId = this.inMemoryStorage.get('facilityId');

        const companyId = this.inMemoryStorage.get('company') || '';
        console.log('Fetching facilities for companyId:', companyId);

        this.productService
            .getFacilities(companyId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    // Use label/value structure for dropdown
                    this.facilities = data.map((f) => ({
                        label: `${f.FACI} - ${f.FACN}`,
                        value: f.FACI
                    }));
                    this.filteredFacilities = this.facilities;
                    this.product.facilityId = facilityId;
                },
                error: () => {
                    this.product.facilityId = facilityId;

                    this.facilities = [];
                    this.filteredFacilities = [];

                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load facilities.', life: 4000 });
                }
            });
    }

    selectedWarehouseCountryCode: string = '';
    fetchWarehouses() {
        const warehouseId = this.inMemoryStorage.get('warehouseId') || '400';

        const companyId = this.inMemoryStorage.get('company') || '080';
        console.log('Fetching warehouses for companyId:', companyId);
        this.productService
            .getWarehouses(companyId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    console.log('Warehouses API response:', data);
                    console.log(this.product, 'Before setting warehouseId');

                    console.log(data.length, 'warehouses found');
                    this.product.warehouseId = warehouseId;

                    if (data.length >= 0) {
                        this.warehouses = data.map((w) => ({
                            label: `${w.whlo} - ${w.whnm}`,
                            value: w.whlo,
                            cscd: w.cscd
                        }));
                        this.filteredWarehouses = this.warehouses;
                        const selectedWarehouse = this.warehouses.find((w) => w.value === this.product.warehouseId);
                        this.selectedWarehouseCountryCode = selectedWarehouse?.cscd || '';
                        console.log('Selected warehouse country code:', this.selectedWarehouseCountryCode);
                        this.calculateVatPercentage();
                    } else {
                        console.log('No warehouses found in response');
                    }
                },
                error: () => {
                    console.log(this.product.countryCode, 'country code before setting warehouseId on error');
                    this.product.warehouseId = warehouseId;

                    this.selectedWarehouseCountryCode = this.product.countryCode || '';
                    this.calculateVatPercentage();

                    console.log('Error fetching warehouses');

                    this.warehouses = [];
                    this.filteredWarehouses = [];
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load warehouses.', life: 4000 });
                }
            });
    }
    fetchOrderTypes() {
        const companyId = this.inMemoryStorage.get('company') || '';
        console.log('Fetching order types for companyId:', companyId);
        this.productService
            .getOrderTypes(companyId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    console.log('Order types API response:', data);

                    // Use label/value structure for dropdown
                    this.orderType = data.orderTypes.map((o: any) => ({
                        label: `${o.orderType} - ${o.description}`,
                        value: o.orderType
                    }));
                    console.log(this.orderType);

                    this.filteredOrderType = this.orderType;
                    console.log('Filtered Order Types:', this.filteredOrderType); // Debug print
                },
                error: () => {
                    this.orderType = [];
                    this.filteredOrderType = [];
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load order types.', life: 4000 });
                }
            });
    }

    // Filter methods for autocomplete
    filterFacilities(event: any) {
        const query = event.query.toLowerCase();
        this.filteredFacilities = this.facilities.filter((f) => f.label.toLowerCase().includes(query));
    }
    filterWarehouses(event: any) {
        const query = event.query.toLowerCase();
        this.filteredWarehouses = this.warehouses.filter((w) => w.label.toLowerCase().includes(query));
    }

    filterOrderType(event: any) {
        const query = event.query.toLowerCase();
        console.log('Filtering order types with query:', query); // Debug print

        console.log('Order Types before filtering:', this.orderType); // Debug print

        this.filteredOrderType = this.orderType.filter((o) => o.label.toLowerCase().includes(query));
        console.log('Filtered Order Types:', this.filteredOrderType); // Debug print
    }

    isSyncDialogVisible: boolean = false;
    syncingOrdersToM3: boolean = false;
    get isSyncing(): boolean {
        return this.productService.getSyncing();
    }
    syncConflictVisible = false;

    closeSyncConflictDialog(): void {
        this.syncConflictVisible = false;
    }
    onSyncAllOrders() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to sync all orders with status 10 to M3?',
            header: 'Confirm Sync All Orders',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.isSyncDialogVisible = true;

                setTimeout(() => {
                    this.isSyncDialogVisible = false;
                }, 2000);
                this.productService.setSyncing(true);
                this.productService
                    .syncOrdersToM3('CustomerOrder')
                    .pipe(takeUntil(this.destroy$))

                    .subscribe({
                        next: (res) => {
                            // this.refreshOrders();
                            this.isSyncDialogVisible = false;

                            this.messageService.add({
                                severity: 'success',

                                summary: 'Sync Completed',
                                detail: 'Sync Completed please refresh the table'
                            });
                            setTimeout(() => {
                                this.productService.setSyncing(false);
                            }, 600000);
                        },
                        error: (err) => {
                            this.loading = false;  // or this.isSyncDialogVisible = false in orderdetails
                            if (err?.status === 409) {
                                setTimeout(() => {
                                    this.syncConflictVisible = true;
                                }, 300);
                            } else {
                                this.messageService.add({
                                    severity: 'error',
                                    summary: 'Sync Failed',
                                    detail: err?.error?.message || 'Failed to sync orders to M3.',
                                    life: 4000
                                });
                            }
                            // ... setSyncing(false) etc.
                            this.productService.setSyncing(false);
                        }
                    });
            }
        });
    }
    onSyncSingleOrder(product: any) {
        if (this.invoiceRuleService.canViewOrderConfirmation(product)) {
            this.navigateToViewOnlyPreview(product);
            return;
        }
        this.navigateToSyncPreview(product);
    }

    isSyncViewOnly(product: any): boolean {
        return this.invoiceRuleService.canViewOrderConfirmation(product);
    }
//     onSyncSingleOrder(product: any) {
//     this.confirmationService.confirm({
//         message: `Are you sure you want to sync order ${product.orderNumber} to M3?`,
//         header: 'Confirm Sync to M3',
//         icon: 'pi pi-exclamation-triangle',
//         accept: () => {

//             this.productService.setSyncing(true);
//             this.loaderService.show(`Syncing order... ${product.orderNumber}`, 'Please wait...');

//             this.productService
//                 .syncSingleOrderToM3(product.orderNumber, 'CustomerOrder')
//                 .pipe(
//                     takeUntil(this.destroy$),
//                     finalize(() => {
//                         this.loaderService.hide();
//                         setTimeout(() => {
//                             this.productService.setSyncing(false);
//                         }, 600000);
//                     })
//                 )
//                 .subscribe({
//                     next: () => {
//                         this.messageService.add({
//                             severity: 'success',
//                             summary: 'Sync Completed',
//                             detail: `Order ${product.orderNumber} synced to M3 successfully`
//                         });
//                         this.refreshOrders();
//                     },
//                     error: (err) => {
//                         this.messageService.add({
//                             severity: 'error',
//                             summary: 'Sync Failed',
//                             detail: err?.error?.message || 'Failed to sync order to M3'
//                         });
//                     }
//                 });
//         }
//     });
// }
getSyncTooltip(product: any): string {
    const status = product.status;
    const moving = product.orderMovingStatus?.toUpperCase();

    if (status === 10 && moving === 'CRT') { // 10 + CRT
        // Division 100 (Germany): no tooltip for this state
        const divisionId = this.userDivision ?? (this.division || '');
        if (divisionId !== '' && this.immediateDivisions.includes(divisionId)) {
            return 'Sync to M3';
        }
        return 'Route Wise Picking list is not created. You cannot sync.';
    }
    if (status === 10 && moving === 'PKL') { // 10 + PKL
        return 'Sync to M3';
    }
    if (status === 15 && moving === 'WIP') {// 15 + WIP
        return 'Error while syncing';
    }
    if (status === 20 && moving === 'WIP') {// 20 + WIP
        return 'View order confirmation';
    }
    if (status === 20 && moving === 'INV') {// 20 + INV
        return 'Syncing is completed';
    }
    if (status === 9 && moving === 'CRT') { // 9 + CRT
        return 'Order is on hold';
    }
    if (status === 9 && moving === 'PKL') {   // 9 + PKL
        return 'Order is on hold';
    }
    if(status === 90 && moving === 'CAN'){
        return 'Cannot sync cancelled order';
    }
    return 'Sync not allowed for this order state';// fallback
}
isSyncDisabled(product: any): boolean {
    if (this.invoiceRuleService.canViewOrderConfirmation(product)) {
        return false;
    }

    const status = product.status;
    const moving = product.orderMovingStatus?.toUpperCase();
    const userDivision = this.userDivision;

        // Division 100 (Germany): allow ONLY 10 + CRT
    if (userDivision && this.immediateDivisions.includes(userDivision)) {
        return !(status === 10 && moving === 'CRT');
    }
    // Division 400 (Netherlands): allow ONLY 10 + PKL
    if (userDivision && this.afterCutoverDivisions.includes(userDivision)) {
        return !(status === 10 && moving === 'PKL');
    }

    //Everything else stays disabled (same as before)
    return true;
}

isCreditNoteOrderRow(product: any): boolean {
  const division = this.division || this.userService.getDivisionId() || '';
  const code = resolveOrderTypeCode(product?.orderTypeId, product?.orderType);
  return isCreditNoteOrder(division, code);
}

getInvoiceTooltip(product: any): string {
  return this.invoiceRuleService.getInvoiceTooltip(product);
}
isInvoiceDisabled(product: any): boolean {
    return !(
        this.invoiceRuleService.canGenerateInvoice(product) ||
        this.invoiceRuleService.canViewOrderConfirmation(product)
    );
}

canSendOrderConfirmationMail(product: any): boolean {
    if (!product) {
        return false;
    }
    const moving = (product.orderMovingStatus || '').toUpperCase();
    return Number(product.status) === 10 && moving === 'CRT';
}

getOrderConfirmationMailTooltip(product: any): string {
    return this.canSendOrderConfirmationMail(product)
        ? 'Send order confirmation'
        : 'Order confirmation mail is available only for created orders.';
}

openOrderConfirmationMail(product: any): void {
    if (!this.canSendOrderConfirmationMail(product) || !product?.orderNumber) {
        return;
    }
    const email = (product.email || product.mail || '').trim();
    this.sendOrderConfirmationMailOrderNumber = product.orderNumber;
    this.sendOrderConfirmationMailTo = email;
    this.orderConfirmationMailHasCustomerEmail = !!email;
    this.sendOrderConfirmationMailVisible = true;
}

sendOrderConfirmationMail(): void {
    const toEmail = (this.sendOrderConfirmationMailTo || '').trim();
    if (!toEmail) {
        this.messageService.add({
            severity: 'warn',
            summary: 'Email required',
            detail: this.orderConfirmationMailHasCustomerEmail
                ? 'Please enter a recipient email address.'
                : 'Mail id not found for customer. Please enter email.'
        });
        return;
    }
    if (!this.sendOrderConfirmationMailOrderNumber) {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Order number is required.'
        });
        return;
    }
    const companyId = this.userService.getCompanyId() || '';
    const divisionId = this.userService.getDivisionId() || '';
    this.sendOrderConfirmationMailLoading = true;
    this.http.post<{ success?: boolean; message?: string }>(
        `${environment.apiUrl}InvoiceAndPicklist/sendPreviewOnMail`,
        {
            orderNumber: this.sendOrderConfirmationMailOrderNumber,
            companyId,
            divisionId,
            toEmail
        }
    ).subscribe({
        next: (res) => {
            this.sendOrderConfirmationMailLoading = false;
            this.sendOrderConfirmationMailVisible = false;
            this.sendOrderConfirmationMailTo = '';
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res?.message || `Order confirmation sent to ${toEmail}.`
            });
        },
        error: (err) => {
            this.sendOrderConfirmationMailLoading = false;
            const msg = err?.error?.message || err?.error?.error || err?.message || 'Failed to send order confirmation.';
            this.messageService.add({
                severity: 'error',
                summary: 'Send failed',
                detail: msg,
                life: 5000
            });
        }
    });
}

    onDontSyncOrder() {
        if (!this.selectedProduct || !this.selectedProduct.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'No Order Selected',
                detail: 'Please select an order to update.',
                life: 4000
            });
            return;
        }
        // Only allow if current status is 10
        if (this.product.status !== 10) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Invalid Status',
                detail: 'Order status must be 10 to mark as Don’t Sync.',
                life: 4000
            });
            return;
        }
    }
    // In your component class
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        console.log('Component Orders destroyed and unsubscribed');
    }
    showCombineDialog = false;

    pickingListTypes = [
        { label: 'Frozen', value: 'frozone' },
        { label: 'NonFrozen', value: 'nonfrozone' }
    ];

    orderStatuses = [
        { label: '10', value: 10 },
        { label: '15', value: 15 },
        { label: '20', value: 20 }
    ];

    // getTodayDate(): string {
    //     const today = new Date();
    //     const yyyy = today.getFullYear();
    //     const mm = String(today.getMonth() + 1).padStart(2, '0');
    //     const dd = String(today.getDate()).padStart(2, '0');
    //     return `${yyyy}-${mm}-${dd}`; // 'YYYY-MM-DD'
    // }

    combineDialogData = {
        pickingListType: 'Frozen', // or 'nonfrozone' as default
        fromDate: this.getTodayDate(),
        toDate: this.getTodayDate(),
        orderStatus: 10
    };

    onCombinePickingListProceed() {
        this.showCombineDialog = false;
        this.router.navigate(['/combine-picking-list'], {
            state: {
                pickingListType: this.combineDialogData.pickingListType,
                fromDate: this.combineDialogData.fromDate,
                toDate: this.combineDialogData.toDate,
                orderStatus: this.combineDialogData.orderStatus
            }
        });
    }
    vatPercentage: number = 0;
    calculateVatPercentage() {
        console.log('Calculating VAT Percentage with txap:', this.product.txap);

        const txap = Number(this.product.txap);
        if (txap === 0) {
            this.vatPercentage = 0;
            this.product.shouldFetchVatPercentage = false;
            console.log('VAT Percentage set to 0 due to txap = 0');
            return;
        }

        if (txap === 1) {
            let customerCountryCode = '';
            console.log('Calculating VAT Percentage with txap = 1', this.product);

            if (this.product.addressId && this.addresses.length > 0) {
                console.log(this.addresses);

                const selectedAddress = this.addresses.find((a) => a.addressId === this.product.addressId);
                console.log('Selected address for VAT calculation:', selectedAddress);

                customerCountryCode = selectedAddress?.full?.countryCode || '';

                console.log('Customer country code from selected address:', customerCountryCode);
            } else {
                customerCountryCode = this.product.countryCode || '';
                console.log('Customer country code from base details:', customerCountryCode);
            }

            const warehouseCountryCode = this.selectedWarehouseCountryCode;
            console.log('Selected warehouse country code:', warehouseCountryCode);

            if (customerCountryCode && warehouseCountryCode && customerCountryCode === warehouseCountryCode) {
                this.product.shouldFetchVatPercentage = true;
                console.log('Country codes match. VAT percentage API will be called.');
            } else {
                this.product.shouldFetchVatPercentage = false;
                console.log('Country codes do not match. VAT percentage API will not be called.');
                this.vatPercentage = 0;
            }
        }
    }
    clear(dt: any, searchInput: HTMLInputElement) {
        dt.clear();
        searchInput.value = '';
        this.globalSearchTerm = '';
        this.globalSearch$.next('');
        this.deliverySearchTerm = '';
        this.deliverySearch$.next('');
        this.isShowingDeliverySearchResults = false;
        this.selectedUserResponsible = null;
        this.isShowingUserResponsibleFilterResults = false;
        this.userResponsibleFilter$.next(null);
    }

// private calculateM3Status(apiValue: any, syncStatus: any, referenceOrderId: any,  movingStatus?: string): string | null {

//   if (apiValue !== null && apiValue !== undefined && apiValue !== '') {
//     return String(apiValue);
//   }

//   if (!apiValue && syncStatus === 20 && referenceOrderId && movingStatus?.toUpperCase() === 'WIP') {
//     return '22';
//   }
 
//   return null;
// }

    getCancellationTooltip(product: Product): string {
        if (product.status === 90 && product.orderMovingStatus === 'CAN') {
            const parts: string[] = [];

            if (product.cancellationReason) {
                parts.push(`Reason: ${product.cancellationReason}`);
            }

            if (product.cancelledBy) {
                parts.push(`Cancelled By: ${product.cancelledBy}`);
            }

            if (parts.length === 0) {
                return 'Order has been cancelled';
            }

            return parts.join('\n');
        }
        return '';
    }
}
